<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../../assets/images/pop/newproject/newproject1.jpg" class="steps step1" v-if="status=='1'">
      <img src="../../../assets/images/pop/newproject/newproject2.jpg" class="steps step1" v-if="status=='2'">
      <div class="stepbtn" @click="nextStep(status)">
        {{ status == '1' ? "下一步" : status == 2 ? "我知道了" : "我知道了" }}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <div class="h-crumbOut">
      <div class="h-crumbs">
        <el-breadcrumb separator="|">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/xiangmu/pm">项目管理</a></el-breadcrumb-item>
          <el-breadcrumb-item><a href="/xiangmu/newProject">项目信息</a></el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="bigDiv">
      <div class="h-piece">
        <!-- 项目信息 -->
        <div class="top">
          <div class="h-pieceTitle2">
            <h1>项目信息</h1>
          </div>
          <div class="pieceCon ccc yxtable">
            <div class="h-pieceCon2">
              <div class="lj_one" style="margin-top:20px;">
                <el-form :model="formLabelAlign" label-position="right" :rules="rules"
                         ref="formLabelAlign1" :inline="true" class="demo-ruleForm h-formbLine">
                  <el-form-item label="项目名称" class="h-elformWrap-1" prop="projectName">

                    <!-- <el-select v-model="formLabelAlign.projectName" :v="formLabelAlign.projectName"
                                                   filterable remote placeholder="请输入"
                                                   :remote-method="showAllFormList">
                                            <el-option v-for="(item) in EuName"
                                                       :key="item.id"
                                                       :label="item.userName"
                                                       :value="item.userName">
                                            </el-option>
                                        </el-select> -->
                    <div v-if="EuName.length == 0">
                      <el-input v-model="formLabelAlign.projectName" @input="changedata"
                                placeholder="请输入"></el-input>

                    </div>
                    <div v-else>
                      <el-input v-model="formLabelAlign.projectName" @input="changedata"
                                placeholder="请输入"></el-input>
                      <div v-show="dataflag" class="xiangmuBoxs">
                        <div class="xiangmus" v-for="(item,index) in EuName" :key="index" @click="changesdata(item)">
                          {{ item.userName }}
                        </div>
                      </div>
                    </div>


                  </el-form-item>
                  <el-form-item label="项目说明" class="h-elformWrap-1" prop="projectDescription">
                    <el-input :disabled="newOrBid" v-model="formLabelAlign.projectDescription"
                              style=" padding-bottom:13px;" placeholder="请输入项目说明"></el-input>
                  </el-form-item>
                  <!-- 展会项目信息 -->
                  <el-form-item v-if="projectType=='1'" label="项目有效期" class="h-elformWrap-2"
                                prop="times">
                    <template>
                      <el-date-picker
                          :clearable="false"
                          v-model="times"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          style="width:100%;"
                      >
                      </el-date-picker>
                    </template>
                  </el-form-item>
                  <el-form-item v-if="projectType=='1'" label="项目资料" class="h-elformWrap-1"
                  >
                    <brupload
                        :refid="formLabelAlign.id"
                        :reftype="zhxm"
                        :showtime="showtime"
                        uploadflag
                        delflag
                    >
                    </brupload>
                  </el-form-item>
                  <el-form-item v-if="projectType=='3'" label="项目价格承诺书" prop="upload2" class="h-elformWrap-1">
                    <brupload
                        v-model="formLabelAlign.upload2"
                        :refid="formLabelAlign.id"
                        tips="请选择pdf文件上传"
                        reftype="jgcns"
                        :showtime="false"
                        :pdfFlag="true"
                        uploadflag
                        delflag
                        accept="application/pdf"
                        @filecallback="fileBack2"
                    >
                    </brupload>
                  </el-form-item>
                  <!-- 展会项目信息 -->
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- 项目信息 -->
        <!-- 内销外销用户信息 -->
        <div v-if="projectType=='3'||projectType=='2'">
          <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
            <h1>经销商信息</h1>
          </div>
          <div class="pieceCon n-bu">
            <div class="h-pieceCon2">
              <div class="h-formLine ">
                <el-form :model="formLabelAlign" label-position=right :rules="rules"
                         ref="formLabelAlign2" :inline="true" class="demo-ruleForm h-formbLine">
                  <el-form-item label="客户名称" class="h-elformWrap-2" prop="customerName" :rules="[
								  { required: true, message: '请输入客户名称', trigger: 'input'},]">
                    <el-input v-model="formLabelAlign.customerName" placeholder="请输入" readonly>
                      <i
                          class="el-icon-search el-input__icon"
                          slot="suffix"
                          @click="openShoudf">
                      </i>
                    </el-input>
                  </el-form-item>
                  <el-form-item label="区域" class="h-elformWrap-2" prop="projectArea">
                    <el-input
                        :disabled="newOrBid"
                        v-model="formLabelAlign.projectArea"
                        placeholder="根据客户自动带出"
                        readonly>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="salesregion" label="销售区域" :rules="[
                    { required: true, message: '请选择销售区域', trigger:['change', ' blur','input']},
                  ]" class="h-elformWrap-2">
                    <el-select v-model="formLabelAlign.salesregion" placeholder="请选择" @change="changeArea($event)"
                               style="width:100%">
                      <el-option v-for="item in salesregionListFilter"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.code"
                                 :disabled="newOrBid">
                      </el-option>
                    </el-select>

                  </el-form-item>

                  <el-form-item v-if="projectType=='3'" prop="customerChannel" label="客户渠道"
                                class="h-elformWrap-2">
                    <el-select v-model="formLabelAlign.customerChannel" placeholder="请选择" style="width:100%">
                      <el-option v-for="item in customerChannelListFilter"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>

                </el-form>
              </div>
            </div>
          </div>
          <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
            <h1>用户信息</h1>
          </div>
          <div class="pieceCon n-bu">
            <div class="h-pieceCon2">
              <el-form :model="formLabelAlign" label-position=right :rules="rules"
                       ref="formLabelAlign2" :inline="true" class="demo-ruleForm h-formbLine">
                <el-form-item v-if="projectType=='3'" label="部门科室" class="h-elformWrap-2"
                              prop="customerDept">
                  <el-input :disabled="newOrBid" v-model="formLabelAlign.customerDept"
                            placeholder="请输入部门科室"></el-input>
                </el-form-item>

                <el-form-item v-if="projectType=='2'" prop="currencyCode" label="币种"
                              class="h-elformWrap-2">
                  <mdmselect category="YLCurrency" :v="formLabelAlign.currencyCode"
                             :disabled="true"
                             :showcode="true"
                             v-model="formLabelAlign.currencyCode"></mdmselect>
                </el-form-item>

                <el-form-item label="关键人" class="h-elformWrap-2" prop="keyPerson">
                  <el-input :disabled="newOrBid" v-model="formLabelAlign.keyPerson"
                            placeholder="请输入关键人"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" class="h-elformWrap-2 " prop="keyPersonTel">
                  <el-input :disabled="newOrBid" v-model="formLabelAlign.keyPersonTel"
                            placeholder="请输入联系电话"></el-input>
                </el-form-item>
                <el-form-item v-if="projectType=='3'" label="预计转化日期" class="h-elformWrap-2"
                              prop="expectConvertDate">
                  <template>
                    <div class=" block">
                      <el-date-picker
                          v-model="formLabelAlign.expectConvertDate"
                          type="date"
                          placeholder="--请选择--"
                          value-format="yyyy-MM-dd"
                          :clearable=false
                          :disabled="newOrBid"
                          :picker-options="pickerOptions"
                          style="width:100%;">
                      </el-date-picker>
                    </div>
                  </template>
                </el-form-item>


                <el-form-item v-if="projectType=='3'" label="收货地址" class="h-elformWrap-2" prop="receivingAddress">
                  <el-input readonly v-model="formLabelAlign.receivingAddress"
                            :title="formLabelAlign.receivingAddress"
                            placeholder="收货地址...">
                    <i
                        class="el-icon-search el-input__icon"
                        slot="suffix"
                        v-if="!newOrBid"
                        @click="handleIconClick">
                    </i>
                  </el-input>
                </el-form-item>

                <el-form-item label="收货单位" prop="toCompanyname" class="h-elformWrap-z" :clearable="true">
                  <el-select v-model="formLabelAlign.toCompanyname" remote
                             filterable :filter-method="showFormList" :v="formLabelAlign.toCompanyname"
                             clearable placeholder="请输入"
                             :remote-method="showFormList">
                    <el-option v-for="(item) in addrList"
                               :key="item.id"
                               :label="item.deptName"
                               :value="item.deptName">
                    </el-option>
                  </el-select>
                </el-form-item>

              </el-form>
            </div>
          </div>
        </div>
        <!-- 内销外销用户信息 -->

        <!-- 采购项目使用产品信息 -->
        <div class="n-hu ljjtablepaddings9" v-if="projectType=='5'">
          <div class="h-pieceTitle2">
            <h1>产品信息</h1>
          </div>

          <div class="yxtable" style="padding-left: 0.15rem;">
            <el-table
                :data="proProduct"
                :border="true">
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="type"
                  label="产品大类">
                <template slot-scope="scope">
                  <el-select class="h-tableInput" v-model="scope.row.type"
                             placeholder="--请选择--"
                             @change="changeBigCg(scope.row)">
                    <el-option
                        v-for="(item,index) in optionsProduct1"
                        :key="index"
                        :label="item.levelname"
                        :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column
                  prop="productName"
                  label="产品型号">
                <template slot-scope="scope">
                  <el-select class="h-tableInput" v-model="scope.row.productName"
                             placeholder="--请选择--"
                             filterable
                             allow-create
                             default-first-option
                             style="vertical-align:bottom"
                  >
                    <el-option
                        v-for="(item,index2) in scope.row.optionsProductCg"
                        @click.native="optionsProduct2Cg(scope.row, item.levelname, item.id)"
                        :key="index2"
                        :label="item.levelname"
                        :value="item.levelname">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>

              <el-table-column
                  prop="xuniFlag"
                  label="产品类型">
                <template scope="scope">
                  {{ scope.row.xuniFlag|dictname('xuni_flag') }}
                </template>
              </el-table-column>
              <el-table-column
                  prop="productId"
                  label="产品编码">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.productId"
                            class="h-tableInput"
                            disabled
                            style="vertical-align:bottom">

                  </el-input>
                </template>
              </el-table-column>

              <el-table-column
                  prop="productNum"
                  label="产品数量">
                <template scope="scope">
                  <el-input class="h-tableInput" :disabled="newOrBid" v-model="scope.row.productNum"
                            placeholder="请填写产品数量"></el-input>
                </template>
              </el-table-column>

              <el-table-column
                  prop="productDes"
                  label="产品描述"
                  min-width="150">
                <template scope="scope">
                  <el-input class="h-tableInput" :disabled="newOrBid" v-model="scope.row.productDes"
                            placeholder="请填写产品描述"></el-input>
                </template>
              </el-table-column>

              <el-table-column
                  v-if="!newOrBid"
                  width="100"
                  label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="delIndex(scope.$index)">删除</el-button>
                  <!-- <div class="l-operationBox">
										<span class="l-operationlist br-operation-delete" title="删除该条" @click="delIndex(scope.$index)"></span>
									</div> -->
                </template>
              </el-table-column>
            </el-table>
            <!--<div v-if="!newOrBid" class="h-tableAdd" @click="addCG">-->
            <!--    <a>新增一行</a>-->
            <!--</div>-->

          </div>
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                       @click="uploaddownexcelflagbtn">批量导入
            </el-button>
            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="projectImportExcel"
                             :startrow="1" @callback="uploadExcelFilecallback"/>
          </div>
        </div>
        <!-- 采购项目使用产品信息 -->

        <!-- 采购项目使用虚拟产品信息 -->
        <br/>
        <div class="n-hu" v-if="showFicPro">
          <div class="h-pieceTitle2">
            <h1>新增虚拟物料</h1>
          </div>
          <div class="h-row h-mrt0">
            <div class="h-rowIn">
              <div class="h-rowBox">
                <div class="h-rowCon">
                  <div class="h-pieceIn2">
                    <div class="h-pieceCon2">
                      <div class="h-formLine clclass">
                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                 :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                          <el-form-item label="业务类型" prop="ywlx" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="IN_TYPE" :v="zy.ywlx"
                                      v-model="zy.ywlx"></brselect>
                          </el-form-item>

                          <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxh">
                            <el-input placeholder="请输入" v-model="zy.wlxh"></el-input>
                          </el-form-item>

                          <el-form-item label="基本单位" prop="jbdw" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLUnit" :v="zy.jbdw"
                                      v-model="zy.jbdw"></brselect>
                          </el-form-item>

                          <el-form-item label="物料组" prop="wlz" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <template>
                              <brselectlazy category="YLMaterialGroup" :v="zy.wlz"
                                            v-model="zy.wlz"></brselectlazy>
                            </template>
                          </el-form-item>
                          <el-form-item label="旧物料号" class="h-elformWrap-2" prop="jwlh">
                            <el-input placeholder="请输入" v-model="zy.jwlh"></el-input>
                          </el-form-item>

                          <el-form-item label="产品组" prop="cpz" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLProductGroup" :v="zy.cpz"
                                      v-model="zy.cpz"></brselect>
                          </el-form-item>
                          <el-form-item label="实验室" prop="sys" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="Laboratory" :v="zy.sys"
                                      v-model="zy.sys"></brselect>
                          </el-form-item>


                          <el-form-item label="外部物料组" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.wbwlz"></el-input>
                          </el-form-item>
                          <el-form-item label="税分类" prop="sfl" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLMtlTaxType" :v="zy.sfl"
                                      v-model="zy.sfl"></brselect>
                          </el-form-item>

                          <el-form-item label="产品注册号" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.cpzch"></el-input>
                          </el-form-item>
                          <el-form-item label="储运条件" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.cytj"></el-input>
                          </el-form-item>
                          <el-form-item label="产地" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.cd"></el-input>
                          </el-form-item>

                          <el-form-item label="产品层次" prop="cpcc" :rules="[
								  { required: true, message: '请选择', trigger: 'blur'},]" class="h-elformWrap-2">
                            <template>
                              <brselectlazy category="YLProdHierarchy" :v="zy.cpcc"
                                            v-model="zy.cpcc"></brselectlazy>
                            </template>

                          </el-form-item>

                          <el-form-item label="生产商" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.scs"></el-input>
                          </el-form-item>


                          <el-form-item label="小微编码" prop="xwbm" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLXW" :v="zy.xwbm"
                                      v-model="zy.xwbm"></brselect>
                          </el-form-item>

                          <el-form-item label="生态硬件属性" prop="styjsx" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLEcology" :v="zy.styjsx"
                                      v-model="zy.styjsx"></brselect>
                          </el-form-item>

                          <el-form-item label="生态收入" prop="stsr" :rules="[
								  { required: false, message: '请选择', trigger: 'blur'},
								]" class="h-elformWrap-2">
                            <brselect category="YLEcologyIn" :v="zy.stsr"
                                      v-model="zy.stsr"></brselect>
                          </el-form-item>

                          <el-form-item label="产品有效期" prop="youxiaoqi" :rules="[
								  {required: true, message: '请输入四位整数年份-只能填写正整数', trigger: 'change'},
								]" class="h-elformWrap-2">

                            <el-input v-model.number="zy.youxiaoqi" placeholder="请输入四位整数年份"
                                      oninput="value=value.replace(/[^\d]/g, '')"
                                      maxlength="4">
                            </el-input>

                          </el-form-item>
                          <el-form-item label="上传凭证" class="h-elformWrap-1" prop="upload">
                            <brupload
                                :refid="chanpinid"
                                :reftype="chanpinziliao"
                                uploadflag
                                delflag>
                            </brupload>
                          </el-form-item>
                          <el-form-item label="行业标准描述" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.hybzms"></el-input>
                          </el-form-item>
                          <el-form-item label="创建人账号" class="h-elformWrap-2">
                            <el-input placeholder="请输入" v-model="zy.cjrzh"
                                      disabled="disabled"></el-input>
                          </el-form-item>

                          <el-form-item label="驳回审批意见" class="h-elformWrap-2"
                                        v-if="chongxintijiaoshow">
                            <el-input v-model="zy.shenpiyijian" placeholder=""
                                      disabled="disabled"></el-input>
                          </el-form-item>

                        </el-form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="h-txtCenter h-mrt60">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="addFicPro(0)">返回</el-button>

            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="chongxintijiaoshow">
              重新提交
            </el-button>

            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancunortijiao(4)" v-if="!chongxintijiaoshow">
              确认
            </el-button>
            <!--                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="zancunortijiao(1)"-->
            <!--                                   v-if="!chongxintijiaoshow">转化真实物料-->
            <!--                        </el-button>-->
          </div>
        </div>
        <!-- 采购项目使用虚拟产品信息 -->


        <!-- 外销附件上传开始 -->
        <div class="n-hu" v-if="projectType=='2'">
          <div class="h-pieceTitle2">
            <h1>附件上传</h1>
          </div>
          <div class="pieceCon n-bu">
            <div class="h-pieceCon2">
              <div class="h-formLine">
                <el-form :model="formLabelAlign" label-position=right :inline="true"
                         class="demo-ruleForm h-formbLine">
                  <el-form-item label="上传PO" class="h-elformWrap-2" prop="poId"
                                style="padding-top:20px">
                    <brupload
                        :refid=formLabelAlign.id
                        :reftype="wxpo"
                        :limit=1
                        :showtime="showtime"
                        uploadflag
                        delflag
                        @filecallback=addfilecallbackpo
                    >
                    </brupload>
                  </el-form-item>
                  <el-form-item label="上传报价单" class="h-elformWrap-2" prop="bjdId"
                                style="padding-top:20px">
                    <brupload
                        :refid="formLabelAlign.id"
                        :reftype="wxpi"
                        :limit=1
                        :showtime="showtime"
                        uploadflag
                        delflag
                        @filecallback=addfilecallbackbjd
                    >
                    </brupload>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- 外销附件上传结束 -->

        <!-- 内销外销展会产品信息 表格 -->
        <div class="h-formLine product n-bu" v-if="projectType=='3'||projectType=='2'||projectType=='1'">
          <div class="h-pieceTitle2">
            <h1>产品信息</h1>
            <el-button size="small" type="primary"
                       icon="el-icon-circle-plus"
                       style="margin-left: 50px;"
                       @click="showLd">选择漏斗
            </el-button>
            <!--    <el-button size="small" type="primary" v-if="zclk"
                                   icon="el-icon-circle-plus"
                                   style="margin-left: 50px;"
                                   @click="showLdTc">选择套餐漏斗
                        </el-button>-->
          </div>
          <el-form :model="formLabelAlign" label-position="right" ref="formLabelAlign" :inline="true"
                   v-if="projectType=='3'"
                   :rules="rules" class="demo-ruleForm h-formbLine">
            <el-form-item label="质保年限" class="h-elformWrap-2" prop="warrantyPeriod" :rules="[
								  { required: true, message: '请输入质保年限', trigger: 'input'},]">
              <el-input v-model="formLabelAlign.warrantyPeriod"
                        placeholder="请输入质保年限" style="width:1.9rem"></el-input>
              <span class="Z-yuan">年</span>
            </el-form-item>
            <el-form-item label="是否改制" class="h-elformWrap-2" prop="formLabelAlign" :rules="[
								  { required: true, message: '请选择是否改制', trigger:['change', ' blur','input']},
								]">
              <el-select v-model="formLabelAlign.isReform" :clearable="true" @change="changeReform"
                         placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="reformFlag" label="改制附件" class="h-elformWrap-2" required>
              <brupload
                  v-model="formLabelAlign.gzFileUrl"
                  :refid=this.formLabelAlign.id
                  reftype="NXXM_GZFJ"
                  :limit="1"
                  :showtime="false"
                  uploadflag
                  delflag>
              </brupload>
            </el-form-item>

            <br>

            <el-form-item label="终端合同" class="h-elformWrap-2" required>
              <brupload
                      v-model="formLabelAlign.gzFileUrl"
                      :refid=this.formLabelAlign.id
                      reftype="项目-终端合同"
                      :limit="1"
                      :showtime="false"
                      uploadflag
                      delflag>
              </brupload>
            </el-form-item>

            <el-form-item v-if="projectType=='3'" label="招标公告" prop="upload1" class="h-elformWrap-2">
              <brupload
                      v-model="formLabelAlign.upload1"
                      :refid="formLabelAlign.id"
                      reftype="zbwj"
                      :showtime="false"
                      uploadflag
                      delflag
                      @filecallback="fileBack1"
              >
              </brupload>
            </el-form-item>

            <el-form-item label="中标公告（带价格）" class="h-elformWrap-2" required>
              <brupload
                      v-model="formLabelAlign.gzFileUrl"
                      :refid=this.formLabelAlign.id
                      reftype="项目-中标公告"
                      :limit="1"
                      :showtime="false"
                      uploadflag
                      delflag>
              </brupload>
            </el-form-item>

            <el-form-item label="发票" class="h-elformWrap-2">
              <brupload
                      v-model="formLabelAlign.gzFileUrl"
                      :refid=this.formLabelAlign.id
                      reftype="项目-发票"
                      :limit="1"
                      :showtime="false"
                      uploadflag
                      delflag>
              </brupload>
            </el-form-item>

            <el-form-item label="是否分销" class="h-elformWrap-2" prop="formLabelAlign" :rules="[
								  { required: true, message: '请选择是否分销', trigger:['change', ' blur','input']},
								]">
              <el-select v-model="formLabelAlign.isFenxiao" :clearable="true" @change="changeFenxiao"
                         placeholder="请选择">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item  v-if="fenxiaoFlag" label="分销合同" class="h-elformWrap-2" required>
              <brupload
                      v-model="formLabelAlign.gzFileUrl"
                      :refid=this.formLabelAlign.id
                      reftype="项目-分销合同"
                      :limit="1"
                      :showtime="false"
                      uploadflag
                      delflag>
              </brupload>
            </el-form-item>

          </el-form>
          <div class="yxtable" style="padding-left: 0.3rem;">
            <el-table
                ref="multipleTable"
                :data="proProduct"
                :border="true"
            >
              <el-table-column
                  type="index"
                  width="40"
                  label="#">
              </el-table-column>
              <el-table-column
                  prop="typeName"
                  label="产品大类"
                  min-width="70">
              </el-table-column>
              <el-table-column
                  prop="productId"
                  label="产品编码"
                  min-width="120">
              </el-table-column>
              <el-table-column
                  prop="productName"
                  label="产品型号"
                  min-width="180">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{ scope.row.productName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="currency"
                  label="币种"
                  v-if="projectType=='2'"
                  min-width="80">
              </el-table-column>
              <el-table-column
                  prop="productPrice"
                  label="基准价格"
                  min-width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ parseFloat(scope.row.productPrice).toFixed(2) }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="applyPrice"
                  label="申请价格"
                  v-if="projectType=='3'"
                  min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.applyPrice"
                            @change="onlynumber2(scope.row)"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>

              <!-- 代理商毛利 -->
              <el-table-column
                      prop="agentMaori"
                      v-if="fenxiaoFlag"
                      label="代理商毛利"
                      min-width="100">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ (Number(scope.row.agentMaori) || 0).toFixed(2) + '%' }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                      prop="fenxiaoPrice"
                      v-if="fenxiaoFlag"
                      label="分销价"
                      min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.fenxiaoPrice"
                            @change="onlynumber2(scope.row)"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>

              <!-- 分销毛利 -->
              <el-table-column
                      prop="fenxiaoMaori"
                      v-if="fenxiaoFlag"
                      label="分销毛利"
                      min-width="100">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ (Number(scope.row.fenxiaoMaori) || 0).toFixed(2) + '%' }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                  prop="biddenPrice"
                  label="终端价格"
                  v-if="projectType=='3'"
                  min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.biddenPrice"
                            @change="onlynumber2(scope.row)"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="productNum"
                  label="产品数量(可编辑)"
                  min-width="100">
                <template scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.productNum"
                            placeholder="请填写产品数量" @change="onlynumber2(scope.row)"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                      prop="shipmentPrice"
                      label="经销商出货单价"
                      v-if="projectType=='3' && this.isGnsc"
                      min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.shipmentPrice"
                            placeholder="填写金额"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>

              <el-table-column
                      prop="otherFees"
                      label="其他费用"
                      v-if="projectType=='3' && this.isGnsc"
                      min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.otherFees"
                            placeholder="填写金额"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                      prop="otherFeesDesc"
                      label="其他费用描述"
                      v-if="projectType=='3' && this.isGnsc"
                      min-width="120">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.otherFeesDesc"
                            placeholder="填写描述"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="projectType=='1'"
                  prop="expoType"
                  label="产品折扣方式"
                  min-width="120">
                <template scope="scope">
                  <brselect
                      class="h-tableInput"
                      category="expo_type"
                      :v="scope.row.expoType"
                      v-model="scope.row.expoType"
                      placeholder="请选择"
                      @change="expoType(scope.row)">
                  </brselect>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="projectType=='1'"
                  prop="expoDiscount"
                  label="产品展销折扣(%)"
                  width="150">
                <template scope="scope">
                  <div v-if="scope.row.expoType=='1'">
                    <el-input class="h-tableInput"
                              v-model.number="scope.row.expoDiscount" placeholder="请填写产品折扣"
                              autocomplete="off" @blur="yanzhengzhekou(scope.row)"></el-input>
                  </div>
                  <div v-if="scope.row.expoType=='2'">
                    {{
                      scope.row.expoDiscount = (new
                      big(scope.row.expoPrice).div(scope.row.productPrice).toFixed(2)) * 100
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="projectType=='1'"
                  prop="expoPrice"
                  label="产品展销单价"
                  width="120">
                <template scope="scope">
                  <div v-if="scope.row.expoType=='1'">
                    {{
                      scope.row.expoPrice = new
                      big(scope.row.productPrice).times(scope.row.expoDiscount).div(100).toFixed(2)
                    }}
                  </div>
                  <div v-if="scope.row.expoType=='2'">
                    <el-input class="h-tableInput" v-if="scope.row.expoType=='2'"
                              v-model.number="scope.row.expoPrice" placeholder="请填写产品单价"
                              autocomplete="off" @blur="yanzhengjiage(scope.row)"></el-input>
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column
                            v-if="projectType==1"
                            prop="expoTotal"
                            label="产品展销总价"
                            width="200">
                                <template scope="scope">
                                    <el-input class="h-tableInput" v-model.number="scope.row.expoTotal" placeholder="根据展销单价和数量计算" readonly></el-input>
                                </template>
                            </el-table-column> -->
              <el-table-column
                  v-if="!newOrBid"
                  width="100"
                  label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="delIndex(scope.$index)">删除</el-button>
                  <!-- <div class="l-operationBox">
										<span class="l-operationlist br-operation-delete" title="删除该条" @click="delIndex(scope.$index)"></span>
									</div> -->
                </template>
              </el-table-column>
            </el-table>
            <!--<div v-if="!newOrBid" class="h-tableAdd" @click="showProcuct1">-->
            <!--    <a>新增一行11</a>-->
            <!--</div>-->

          </div>
        </div>
        <!-- 内销外销展会产品信息 表格 -->
        <!-- 内销中标信息 -->
        <div v-if="projectType=='3'" class="whether">
          <span class="whetherTitle">是否中标</span>
          <template>
            <!--<el-radio v-model="formLabelAlign.isSuccess" label="2">未发布</el-radio>-->
            <el-radio v-model="formLabelAlign.isSuccess" label="1">中标</el-radio>
            <el-radio v-model="formLabelAlign.isSuccess" label="0"> 丢标</el-radio>
          </template>
        </div>
        <!-- 其他公司产品 表格 -->
        <div class="h-formLine product n-bu" v-if="projectType=='3'||projectType=='2'||projectType=='1'">
          <div class="h-pieceTitle2">
            <h1>其他公司产品</h1>
          </div>
          <div class="yxtable" style="padding-left: 0.3rem;">
            <el-table
                    ref="multipleTable"
                    :data="proOtherProduct"
                    :border="true"
            >
              <el-table-column
                      type="index"
                      width="40"
                      label="#">
              </el-table-column>
              <el-table-column
                      prop="typeName"
                      label="产品大类"
                      min-width="70">
              </el-table-column>
              <el-table-column
                      prop="productId"
                      label="产品编码"
                      min-width="120">
              </el-table-column>
              <el-table-column
                      prop="productName"
                      label="产品型号"
                      min-width="180">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{scope.row.productName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                      prop="currency"
                      label="币种"
                      v-if="projectType=='2'"
                      min-width="80">
              </el-table-column>
              <el-table-column
                      prop="productPrice"
                      label="基准价格"
                      min-width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{parseFloat(scope.row.productPrice).toFixed(2)}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                      prop="applyPrice"
                      label="申请价格"
                      v-if="projectType=='3'"
                      min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.applyPrice"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>

              <!-- 代理商毛利 -->
              <el-table-column
                      prop="agentMaori"
                      label="代理商毛利"
                      min-width="100">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.agentMaori"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                      prop="biddenPrice"
                      label="终端价格"
                      v-if="projectType=='3'"
                      min-width="90">
                <template slot-scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.biddenPrice"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                      prop="productNum"
                      label="产品数量(可编辑)"
                      min-width="100">
                <template scope="scope">
                  <el-input :disabled="newOrBid" class="h-tableInput" v-model="scope.row.productNum"
                            placeholder="请填写产品数量"
                            autocomplete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                      v-if="!newOrBid"
                      width="100"
                      label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="delOtherIndex(scope.$index)">删除</el-button>
                  <!-- <div class="l-operationBox">
                      <span class="l-operationlist br-operation-delete" title="删除该条" @click="delIndex(scope.$index)"></span>
                  </div> -->
                </template>
              </el-table-column>
            </el-table>
            <div v-if="!newOrBid" class="h-tableAdd" @click="showProcuct1">
              <a>新增一行</a>
            </div>

          </div>
        </div>
        <!-- 其他公司产品 表格 -->
        <br>

        <div style="width: 100%;" class="h-formLine product zhongTs"
             v-if="projectType=='3'&&(formLabelAlign.isSuccess=='0'||formLabelAlign.isSuccess=='1')">
          <div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.1rem;">
              <h1 v-if="formLabelAlign.isSuccess=='1'">中标信息</h1>
              <h1 v-if="formLabelAlign.isSuccess=='0'">丢标信息</h1>
            </div>
            <br>
            <el-form :model="proBidInfo" label-position="right" ref="proBidInfo" :inline="true"
                     class="demo-ruleForm h-formbLine form">
              <el-form-item label="投标金额" class="h-elformWrap-2" prop="bidTotal" :rules="[
								  { required: true, message: '请输入投标金额', trigger: 'input'},]">
                <el-input @keyup.native='keyupEvent($event,input)'
                          v-model="proBidInfo.bidTotal"
                          placeholder="请输入投标金额" style="width:3.8rem"></el-input>
                <span class="Z-yuan">万元</span>
              </el-form-item>
              <div class="hetong" v-if="formLabelAlign.isSuccess=='1'&!htok">
                <el-row>
                  <el-col :span="12">
                    <span style="font-size:0.16rem;">合同编码</span>
                  </el-col>
                  <el-col :span="12">
                    <el-button
                            class="h-btn h-bBtn h-bgblueQ2"
                            style="margin-top: -0.1rem;"
                            @click="createdemand">关联合同
                    </el-button>
                  </el-col>
                </el-row>
              </div>
              <el-form-item v-if="htok" label="合同编码" class="h-elformWrap-2" prop="contractCode">
                <el-input v-model="proBidInfo.contractCode" readonly style="width:3.8rem"></el-input>
              </el-form-item>
            </el-form>
            <div class="tan">
              <el-dialog
                      :visible.sync="dialogVisible"
                      width="41%"
                      class="h-dialog2"
              >
                <div class="h-dialogImg">
                  <div class="h-disTable">
                    <div class="h-tableCell">
                      <h1>关联合同</h1>
                      <p>Relationship Agreement</p>
                    </div>
                  </div>
                </div>
                <div class="h-formLine" style="margin: 0.38rem 0 0 0;">
                  <el-form :model="proBidInfo" style="margin-left:20px">
                    <el-form-item label="合同编号" class="h-elformWrap-2" prop="contractCode">
                      <el-input v-model="proBidInfo.contractCode" placeholder="请输入合同编号"
                                style="width:50%;height:10px;"></el-input>
                    </el-form-item>
                    <el-form-item label="合同上传" class="h-elformWrap-1">
                      <brupload
                              :refid="formLabelAlign.id"
                              reftype="htsc"
                              :showtime="false"
                              uploadflag
                              delflag
                      >
                      </brupload>
                    </el-form-item>
                  </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="dialogVisible = false">取 消</el-button>
                  <el-button class="h-btn h-bBtn" @click="checkUnFreeze">确 定</el-button>
                </div>
              </el-dialog>
            </div>
          </div>
          <div class="h-formLine product ljjtablepaddings9" v-if="formLabelAlign.isSuccess=='1'" style="width: 100%;">
            <!-- <el-form :model="proBidInfo" label-position="right" ref="proBidInfo" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="其他投标品牌" class="h-elformWrap-2" prop="otherBrand">
                                <el-input v-model="proBidInfo.otherBrand" placeholder="请输入其他投标品牌"></el-input>
                            </el-form-item>
                            <el-form-item label="其他投标公司" class="h-elformWrap-2 " prop="otherComp">
                                <el-input v-model="proBidInfo.otherComp" placeholder="请输入其他投标公司"></el-input>
                            </el-form-item>
                            <el-form-item label="其他公司投标总额" class="h-elformWrap-2" prop="otherTotal">
                                <el-input oninput="value=value.replace(/[^0-9\,]/,'')" v-model="proBidInfo.otherTotal"
                                          placeholder="请输入其他公司投标总额"></el-input>
                                <span class="yuan">万元</span>
                            </el-form-item>/[^0-9\,]/,
                        </el-form> -->

            <div style="margin-bottom: 0.3rem;padding-left: 0.3rem;">
              <el-table
                  ref="multipleTable"
                  :data="zhongbiaodata"
                  style="width: 100%"
                  :border="true"
              >
                <el-table-column
                    type="index"
                    width="40"
                    label="#">
                </el-table-column>
                <el-table-column
                    prop="otherBrand"
                    label="其他投标品牌11"
                >
                  <template scope="scope">
                    <el-input class="h-tableInput" v-model="scope.row.otherBrand" style="height: 0.35rem;"
                              placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="otherModel"
                    label="投标型号">
                  <template scope="scope">
                    <el-input class="h-tableInput" v-model="scope.row.otherModel" style="height: 0.35rem;"
                              placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="otherComp"
                    label="其他投标公司"
                >
                  <template scope="scope">
                    <el-input class="h-tableInput" v-model="scope.row.otherComp" style="height: 0.35rem;"
                              placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="otherTotal"
                    label="其他公司投标总额"
                >
                  <template scope="scope">
                    <el-input class="h-tableInput" v-model="scope.row.otherTotal" style="height: 0.35rem;"
                              placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="100"
                    fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="delzhongbiao(scope.$index)">删除
                    </el-button>
                    <!-- <div class="l-operationBox">
											<span class="l-operationlist br-operation-delete" title="删除该条" @click="delzhongbiao(scope.$index)"></span>
										</div> -->
                  </template>
                </el-table-column>
              </el-table>
              <div class="h-tableAdd" @click="addzhongbiao">
                <a>新增</a>
              </div>
            </div>


          </div>
          <div class="h-formLine product zhongT" v-if="formLabelAlign.isSuccess=='0'">
            <el-form :model="proBidInfo" label-position="right" ref="proBidInfo" :inline="true"
                     class="demo-ruleForm h-formbLine">
              <el-form-item label="中标公司" class="h-elformWrap-2" prop="successComp">
                <el-input v-model="proBidInfo.successComp" placeholder="请输入中标公司"></el-input>
              </el-form-item>
              <el-form-item label="丢标金额" class="h-elformWrap-2 " prop="failTotal">
                <span class="yuan">万元</span>

                <el-input oninput="value=value.replace(/[^\d]/g,'')" v-model="proBidInfo.failTotal"
                          placeholder="请输入丢标金额"></el-input>
              </el-form-item>
              <el-form-item label="丢标原因" class="h-elformWrap-2" prop="failReason">
                <el-input v-model="proBidInfo.failReason" placeholder="请输入丢标原因"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!-- 内销中标信息 -->

        <!-- 竞品 内销外销 用户在用产品信息 -->
        <template>
          <div>
            <div v-if="projectType=='3'||projectType=='2'" class="h-pieceIn2">
              <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
              <div class="h-pieceTitle2" style="margin-bottom: 0.4rem;">
                <h1>用户在用产品信息</h1>
              </div>
              <div class="h-pieceCon2 yxtable" style="padding-left: 0.3rem;">
                <div class="h-formLine clclass ljjtablepaddings9" style="margin-bottom:50px;">
                  <div class="categoryBox">
                    <div class="category" :class="{'active':item==categorys}"
                         @click="selectC(item)" v-for="(item,index) in category"
                         :key="index">{{ item }}
                    </div>
                  </div>
                  <div v-if="categorys == '海尔产品'" style="margin-top:20px;">
                    <el-table
                        ref="multipleTable"
                        :data="productInfosHaier"
                        style="width: 100%"
                        :border="true"
                    >
                      <el-table-column
                          type="index"
                          width="40"
                          label="#">
                      </el-table-column>
                      <el-table-column
                          prop="category"
                          label="产品大类"
                          width="150">
                        <template scope="scope">
                          <el-select v-model="scope.row.category"
                                     placeholder="--请选择--"
                                     filterable
                                     @change="changeBigHaierBig(scope.row,scope.$index)"
                                     class="h-tableInput"
                          >
                            <el-option
                                v-for="(item,index) in optionsProductBig"
                                :key="index"
                                :label="item.levelname"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="specification"
                          label="产品型号"
                          width="150">
                        <template scope="scope">
                          <el-select v-model="scope.row.specification"
                                     placeholder="--请选择--"
                                     filterable
                                     class="h-tableInput"
                          >
                            <el-option
                                v-for="(item,index2) in optionsProductHaier[scope.$index]"
                                :key="index2"
                                :label="item.levelname"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="amount"
                          label="产品数量"
                          width="100">
                        <template scope="scope">
                          <el-input v-model="scope.row.amount" class="h-tableInput"
                                    placeholder="请输入"
                                    @change="onlynumber(scope.row)"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="barCode"
                          label="条形码"
                          width="150">
                        <template scope="scope">
                          <el-input v-model="scope.row.barCode" class="h-tableInput"
                                    placeholder="请输入"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="isOverdue"
                          label="是否超限期使用"
                          width="170">
                        <template scope="scope">
                          <brselect category="isOverdue" class="h-tableInput"
                                    :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                    placeholder="--请选择--"></brselect>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="exfactoryDate"
                          label="出厂日期"
                          width="180"
                      >
                        <template scope="scope">
                          <div class="block">
                            <el-date-picker
                                @change="beginDate(scope.row)"
                                v-model="scope.row.exfactoryDate"
                                type="date"
                                placeholder="--请选择--"
                                value-format="yyyy-MM-dd"
                                class="h-tableInput"
                                :clearable=false>
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="purchaseDate"
                          label="购买日期"
                          width="180"
                      >
                        <template scope="scope">
                          <div class="block">
                            <el-date-picker
                                @change="processDate(scope.row)"
                                v-model="scope.row.purchaseDate"
                                type="date"
                                placeholder="--请选择--"
                                value-format="yyyy-MM-dd"
                                class="h-tableInput"
                                :clearable=false>
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="产品照片"
                          width="150">
                        <template slot-scope="scope">
                          <brupload
                              style="margin-top: 0.04rem;"
                              :refid=scope.row.id
                              :reftype=jingpinHaier
                              :showtime="showtime"
                              uploadflag
                              delflag
                          >
                            <el-button size="small" type="text">上传</el-button>
                          </brupload>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="remark"
                          label="备注"
                          width="180"
                      >
                        <template scope="scope">
                          <el-input class="h-tableInput" v-model="scope.row.remark"
                                    placeholder="请输入"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作"
                          width="100">
                        <template slot-scope="scope">
                          <el-button type="text" size="small"
                                     @click="delUserProduction1(scope.$index)">删除该条
                          </el-button>
                          <!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction1(scope.$index)"></span>
													</div> -->
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="h-tableAdd" @click="addHaier">
                      <a>新增在用海尔产品</a>
                    </div>
                  </div>
                  <div v-if="categorys == '竞品'" style="margin-top:20px;">
                    <el-table
                        ref="multipleTable"
                        :data="productInfosOther"
                        style="width: 100%"
                        :border="true"
                    >
                      <el-table-column
                          type="index"
                          width="40"
                          label="#">
                      </el-table-column>
                      <el-table-column
                          prop="category"
                          label="产品大类"
                          width="150">
                        <template scope="scope">
                          <el-select v-model="scope.row.category"
                                     placeholder="--请选择--"
                                     filterable
                                     class="h-tableInput"
                          >
                            <el-option
                                v-for="(item,index) in optionsProductBig"
                                :key="index"
                                :label="item.levelname"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="brand"
                          label="产品品牌"
                          width="150">
                        <template scope="scope">
                          <el-select v-model="scope.row.brand"
                                     placeholder="--请选择--"
                                     filterable
                                     class="h-tableInput"
                                     @change="getBrandName(scope.row,scope.$index)"
                          >
                            <el-option
                                v-for="(item,index) in comperOption"
                                :key="index"
                                :label="item.brandName"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="specification"
                          label="产品型号"
                          width="150">
                        <template scope="scope">
                          <el-input v-model="scope.row.specification" class="h-tableInput"
                                    placeholder="请填写产品型号"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="amount"
                          label="产品数量"
                          width="100">
                        <template scope="scope">
                          <el-input v-model="scope.row.amount" class="h-tableInput"
                                    placeholder="请输入"
                                    @change="onlynumber(scope.row)"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="barCode"
                          label="条形码"
                          width="150">
                        <template scope="scope">
                          <el-input v-model="scope.row.barCode" class="h-tableInput"
                                    placeholder="请填写"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="isOverdue"
                          label="是否超限期使用"
                          width="170">
                        <template scope="scope">
                          <brselect category="isOverdue" class="h-tableInput"
                                    :v="scope.row.isOverdue" v-model="scope.row.isOverdue"
                                    placeholder="--请选择--"></brselect>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="exfactoryDate"
                          label="出厂日期"
                          width="180">
                        <template scope="scope">
                          <div class="block">
                            <el-date-picker
                                @change="beginDate(scope.row)"
                                v-model="scope.row.exfactoryDate"
                                type="date"
                                class="h-tableInput"
                                placeholder="--请选择--"
                                value-format="yyyy-MM-dd"
                                :clearable=false>
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="purchaseDate"
                          label="购买日期"
                          width="180">
                        <template scope="scope">
                          <div class="block">
                            <el-date-picker
                                @change="processDate(scope.row)"
                                v-model="scope.row.purchaseDate"
                                class="h-tableInput"
                                type="date"
                                placeholder="--请选择--"
                                value-format="yyyy-MM-dd"
                                :clearable=false>
                            </el-date-picker>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="产品照片"
                          width="150">
                        <template slot-scope="scope">
                          <brupload
                              style="margin-top: 0.04rem;"
                              :refid=scope.row.id
                              :reftype=jingpinOther
                              :showtime="showtime"
                              uploadflag
                              delflag
                          >
                            <el-button size="small" type="text">上传</el-button>
                          </brupload>
                        </template>
                      </el-table-column>
                      <el-table-column
                          prop="remark"
                          label="备注"
                          width="180"
                      >
                        <template scope="scope">
                          <el-input v-model="scope.row.remark" class="h-tableInput"
                                    placeholder="请输入"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column
                          label="操作"
                          width="100">
                        <template slot-scope="scope">
                          <el-button type="text" size="small"
                                     @click="delUserProduction2(scope.$index)">删除
                          </el-button>
                          <!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除该条" @click="delUserProduction2(scope.$index)"></span>
													</div> -->
                        </template>
                      </el-table-column>
                    </el-table>
                    <div class="h-tableAdd" @click="addComp">
                      <a>新增在用竞品产品</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 竞品 内销外销 用户在用产品信息 -->


      </div>
      <el-row style="display: flex;justify-content: center;margin: 30px 0;">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancelPro">返回</el-button>
        <!--<el-button class="h-btn h-bBtn h-bgblueQ2" v-if="projectType=='5'" @click="addFicPro(1)">新增虚拟物料-->
        <!--</el-button>-->
        <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>-->
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitPro()">确认提交</el-button>

      </el-row>
    </div>

    <!--物料-->
    <wxwlxmother
        :visible.sync="showwuliaodialog1"
        v-if="showwuliaodialog1"
        @choseObj="choseWuliao1"
        :usercode="formLabelAlign.customerId"
        :xmtype="projectType"
        :currency="formLabelAlign.currencyCode"
        :channel="formLabelAlign.customerChannel"
        title="选择物料"/>

    <!--选择客户-->
    <shoudfxm
        :visible.sync="showshdfdialog"
        v-if="showshdfdialog"
        @choseObj="choseshoudf"
        :xmtype="projectType"
        oneflag
        title="选择客户"/>

    <!--收货地址-->
    <areaSelect :visible.sync="showflag" @choseObj="choseAddress" v-if="showflag"
                v-model="formLabelAlign.receivingAddress"/>
    <!--漏斗界面-->
    <loudnew :visible.sync="loud" v-if="loud" @getChildValue="LoudParts"
             :customerName="this.formLabelAlign.customerName"
             :customerChannel="this.formLabelAlign.customerChannel"
             :toCompanyname="this.formLabelAlign.toCompanyname"
             :customercode="this.formLabelAlign.customerId"
             :currencyCode="this.formLabelAlign.currencyCode"
             :areaCode="this.formLabelAlign.areaCode"
             :isTc=true
             :ddlx="'1,1'"
             title="选择漏斗"/>
    <!--漏斗界面-->
    <loudnew :visible.sync="loudTc" v-if="loudTc" @getChildValue="LoudPartsTc"
             :customerName="this.formLabelAlign.customerName"
             :customerChannel="this.formLabelAlign.customerChannel"
             :toCompanyname="this.formLabelAlign.toCompanyname"
             :customercode="this.formLabelAlign.customerId"
             :currencyCode="this.formLabelAlign.currencyCode"
             :areaCode="this.formLabelAlign.areaCode"
             :isTc=true
             :ddlx="'1,12'"
             title="选择漏斗套餐"/>

  </div>
</template>

<style scoped>

.n-bu .el-input--suffix .el-input__inner {
  padding-left: 45px;
}

.zhongT {
  border: none;
  margin-left: 19px;
}

.Z-yuan {
  position: absolute;
  left: 69%;
}

.yuan {
  position: absolute;
  left: 88%;
}

.n-bu .h-formbLine .h-elformWrap-2,
.n-chan .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}

.zhongT .h-formbLine .h-elformWrap-2 {
  width: 50%;
}

.zhongT .h-formbLine .Z-biao.h-elformWrap-2 {
  width: 50%;
}

.pieceCon, .product {
  border-radius: 4px;
}

h1 {
  margin-left: 15px;
}

.bigDiv .h-piece .top .ccc {
  margin-top: -13px;
}

.N-chan .h-pieceTitle2 {
  margin-bottom: 0.4rem;
  margin-left: 0;
}

.whetherTitle {
  margin-right: 20px;
  font-size: 0.16rem;
}

.Z-biao {
  margin-left: 76px;
}

.hetong {
  display: inline-block;
}

.bigDiv {
  margin: 20px;
}

h6 {
  padding-left: 21px;
  color: rgb(72, 144, 226);
  margin-bottom: 10px;
  font-size: 15px;
}

.whether {
  margin-top: 30px;
  font-size: 13px;
  margin-left: 32px;
  padding-bottom: 20px;
}

.categoryBox {
  display: flex;
  border-bottom: 1px solid #dcdfe1;
}

.categoryBox .category {
  width: 1.22rem;
  height: 0.36rem;
  color: #b0b0b0;
  font-size: 0.16rem;
  text-align: center;
  line-height: 0.34rem;
  margin-left: 0.2rem;
  border: 1px solid #b4b4b4;
  cursor: pointer;
  border-bottom: 0;
}

.categoryBox .category:first-child {
  margin-left: 0;
}

.categoryBox .category.active {
  color: #fff;
  border: 1px solid #1b78e6;
  background: #1b78e6;
}

</style>
<style>
.el-radio__label {
  font-size: 0.16rem;
}

.product .tan .h-formbLine .el-form-item__label {
  width: 20%;
}

.block .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 168px;
}

.lj_one .h-formbLine .el-form-item__label {
  width: 13.5%;
}

.lj_one .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 29%;
}

.lj_one .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 71%;
}

.lj_one .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 86.5%;
}

.zhongTs .h-formbLine .el-form-item__content {
  width: 75%;
}

.zhongTs .h-formbLine .el-form-item__label {
  width: 25%;
}

.n-bu .h-formbLine .el-form-item__label {
  width: 47%;
  vertical-align: top;
}

.n-bu .h-formbLine .el-form-item__content {
  width: 53%;
}

.n-bu .h-formbLine .h-elformWrap-3 {
  width: 100%;
}

.n-bu .h-formbLine .h-elformWrap-3 .el-form-item__label {
  width: 10.7%;
}

.n-bu .h-formbLine .h-elformWrap-3 .el-form-item__content {
  width: 73.3%;
}

.yxtable .el-table tbody td .cell {
  padding: 0 0.05rem;
}

.yxtable .el-date-editor .el-range-separator {
  line-height: 0.25rem;
  font-size: 0.16rem;
  width: 8%;
}

</style>
<script>
import big from 'big.js'
import ss from '../../../api/SystemService';
import wxwlxm from '../../../components/dialog/wxwl-xm'
import wxwlxmother from '../../../components/dialog/wxwl-xm-other'
import shoudfxm from '../../../components/dialog/selectshdfXm'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel';
import _ from "loadsh";

export default {
  components: {
    wxwlxm, shoudfxm, uploaddownexcel,wxwlxmother
  },

  data() {
    return {

      EuName: [],
      uploaddownexcelflag: false,

      xuniwuliaoId: '',

      /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓虚拟物料相关↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
      chongxintijiaoshow: false,
      //ywid
      ywid: null,
      //instid
      instid: null,
      //taskid
      taskid: null,
      qianyeshuju: {},
      //物料id
      chanpinid: '',
      //资料类型名称
      chanpinziliao: 'shangchuanpingzheng',
      f: {
        userName: '',
      },
      zy: {
        id: null,
        ywlx: null,
        wlxh: null,
        wlms: null,
        jbdw: null,
        wlz: null,
        jwlh: null,
        cpz: null,
        sys: null,
        wbwlz: null,
        sfl: null,
        cpzch: null,
        cytj: null,
        cd: null,
        cpcc: null,
        scs: null,
        xwbm: null,
        styjsx: null,
        stsr: null,
        youxiaoqi: null,
        pingzheng: null,
        hybzms: null,
        cjrzh: null,
        shenpiyijian: null,
      },
      // cities: cityOptions,
      rules: {
        ywlx: [
          {required: true, message: '请选择业务类型', trigger: 'blur'}
        ],
        wlxh: [
          {required: true, message: '请选择物料型号', trigger: 'blur'}
        ],
        wlms: [
          {required: true, message: '请输入物料描述', trigger: 'blur'}
        ],
        jbdw: [
          {required: true, message: '请选择基本单位', trigger: 'blur'}
        ],
        wlz: [
          {required: true, message: '请选择物料组', trigger: 'blur'}
        ],
        jwlh: [
          {required: true, message: '请输入旧物料号', trigger: 'blur'}
        ],
        sfl: [
          {required: true, message: '请选择税分类', trigger: 'blur'}
        ],
        cpcc: [
          {required: true, message: '请选择产品层次', trigger: 'blur'}
        ],

      },
      //合同上传
      htsc: '',

      /*↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑虚拟物料↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑*/

      showflag: false,
      showFicPro: false,
      showOrhide: false,
      loud: false, //订单关联漏斗 漏斗界面
      loudTc: false,
      status: 1,
      checked: true,
      toshow: "newProject2",
      //物料选择界面
      showwuliaodialog1: false,
      //客户渠道list
      customerChannelList: [],
      customerChannelListFilter: [],
      //销售区域
      salesregionList: [],
      salesregionListFilter: [],
      productlist: [],
      currentUser: null,
      showshdfdialog: false,
      newxm: {
        userName: null,
      },
      showtime: false,
      dialogVisible: false,
      zclk: false,
      //项目类型:1-展会项目,2-外销,3-内销,4-租赁,5-采购,6-服务项目
      times: [],
      projectType: 3,
      newOrBid: true,
      proBidInfo: {
        bidTotal: '',
        contractCode: ''
      },
      formInline: {},
      formLabelAlign: {
        id: this.getUUid(),
        projectName: '', //项目名称
        optionsProductCg: [],
        type: '',
        isSuccess: "1",
        proBidInfoList: [],
        proProductInfoList: [],
        proProductInfoOtherList: [],
        times: [],
        upload1: null,
        upload2: null,
        receivingAddress: '',
        toCompanyname: '', // 收货 单位
        warrantyPeriod: '',
        isReform: '',
        isFenxiao: '',
        gzFileUrl: '',
        customerName: '',//客户名称
        gscode:'',//公司
      },
      addrList: [], //收货 单位
      value1: '',
      optionsCustomer: [],
      //产品信息
      proProduct: [],
      proProductcgList: [],
      proOtherProduct: [],
      proProductcg: {},
      productName: null,
      type: null,
      productNum: '',
      productDes: '',
      productId: '',
      optionsProductCg: {},
      //产品大类选项
      optionsProduct1: [{}],
      //产品小类选项
      optionsProduct2: [{}],
      optionsArea: [],
      customeInfo: {},
      //竞品使用
      //带线表单
      categorys: '海尔产品',
      category: ['海尔产品', '竞品'],
      //附件类别
      jingpinOther: "竞品信息-其他品牌",
      jingpinHaier: "竞品信息-海尔",
      wxpo: "外销项目-PO",
      wxpi: "外销项目-PI",
      zhxm: "展会项目-资料",
      filepo: [],
      filebjd: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      },
      //竞争对手
      comperOption: [],
      //产品大类选项
      optionsProductBig: [],
      //产品小类选项
      optionsProductHaier: [{}],
      //海尔产品竞品
      productInfosHaier: [{id: this.getUUid2(), type: 1, fromType: 1, specification: '', brand: "Haier"}],
      //其他品牌产品竞品
      productInfosOther: [{id: this.getUUid2(), type: 2, fromType: 1,}],
      rules: {
        projectName: [{required: true, message: '请输入项目名称', trigger: 'blur'}],
        projectDescription: [{required: true, message: '请输入项目说明', trigger: 'blur'}],
        customerName: [{required: true, message: '请选择客户', trigger: 'change'}],
        //    projectArea: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
        //    customerChannel: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
        //    customerDept: [{ required: true, message: '根据客户自动带出', trigger: 'blur'}],
        keyPerson: [{required: true, message: '请输入联系人', trigger: 'blur'}],
        keyPersonTel: [{required: true, message: '请输入联系人电话', trigger: 'blur'}],
        expectConvertDate: [{required: true, message: '请选择转化日期', trigger: 'change'}],
        receivingAddress: [{required: true, message: '请选择收货地址', trigger: 'change'}],
        type: [{required: true, message: '请选择产品大类', trigger: 'blur'}],
        productId: [{required: true, message: '请先选择产品大类后选择产品型号', trigger: 'change'}],
        productPrice: [{required: true, message: '根据产品型号自动带出', trigger: 'change'},
          {type: 'number', message: '必须为数字值'}
        ],
        productNum: [{required: true, message: '请输入产品数量', trigger: 'blur'},
          {pattern: /^[1-9]\d{0,10}$/, message: '只能输入十一位以内的正整数'}],
        upload1: [
          {required: true, message: '请上传招标公告', trigger: 'blur'}
        ],
        upload2: [
          {required: true, message: '请上传文件', trigger: 'blur'}
        ],
        toCompanyname: [{required: true, message: '请输入收货单位', trigger: 'blur'}],
      },
      //
      htok: false,
      isGnsc:false,
      gscode:null,
      //限制不能重复
      norepeat: [],

      //限制不能重复
      noreOtherpeat: [],
      dataflag: false,
      zhongbiaodata: [
        {
          otherBrand: '',
          otherModel: '',
          otherComp: '',
          otherTotal: ''
        }
      ],
      reformFlag: false,
      fenxiaoFlag: false,
    }
  },
  mounted() {
    this.xuqiuzhuanhua();
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    this.initType();
    //this.selectCustomer();
    this.selectProduct1();
    //竞品使用
    this.selectProductBig();
    this.selectComperOption();
    // this.addCG();
    if (this.projectType == '5') {
      this.ficMethod();
    }
  },
  methods: {
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {

      this.proProduct = rd.msg;

    },
    keyupEvent(e, input) {
      e.target.value = e.target.value.replace(/[^\d.]/g, '');
      e.target.value = e.target.value.replace(/\.{2,}/g, '.');
      e.target.value = e.target.value.replace(/^\./g, '0.');
      e.target.value = e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0, e.target.value.length - 1));
      e.target.value = e.target.value.replace(/^0[^\.]+/g, '0')
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2')
      this.input = e.target.value
    },
    handleIconClick() {
      this.showflag = true;
    },
    choseAddress(obj) {
      console.log(obj)
      this.showflag = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign.receivingAddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign.receivingAddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    //需求转化产品信息带出
    xuqiuzhuanhua() {
      if (this.$route.query.demandType) {
        var xuqiuid = this.$route.query.id;
        if (this.$route.query.demandType == 1) {
          ss.UserDemand.showcgproduct(xuqiuid).then(rd => {
            rd.forEach(ele => {
              var data = {
                type: ele.levelcode,
                typeName: ele.levelname,
                productName: ele.proname,
                xuniFlag: ele.xuniFlag,
                productId: ele.procode,
                productNum: ele.number,
                productDes: ele.resDescribe,
              }
              this.proProduct.push(data);
            })
          })
        }
      }

    },
    // 添加中标信息
    addzhongbiao() {
      var a = {pinpai: '', xinghao: '', company: '', zonge: ''}
      this.zhongbiaodata.push(a)
    },
    // 删除中标信息
    delzhongbiao(v) {
      this.zhongbiaodata.splice(v, 1)
    },
    fileBack1(v) {
      console.log(v)
      this.formLabelAlign.upload1 = v.length;
    },
    fileBack2(v) {
      console.log(v)
      // this.formLabelAlign.upload2 = v.length;
      this.formLabelAlign.upload2 = v.length == 0 ? '' : v.length;
    },
    yanzhengzhekou(x) {
      if (x.expoDiscount > 100) {
        x.expoDiscount = 100
        this.$msg.msge('折扣范围为0-100')
      }
      if (x.expoDiscount < 0) {
        x.expoDiscount = 0
        this.$msg.msge('折扣范围为0-100')
      }
    },
    yanzhengjiage(x) {
      if (x.expoPrice > x.productPrice) {
        x.expoPrice = x.productPrice
        this.$msg.msge('折扣范围为0-100')
      }
      if (x.expoPrice < 0) {
        x.expoPrice = 0
        this.$msg.msge('折扣范围为0-100')
      }
    },
    changedata(value) {
      if (this.projectType == '5') {


        return;
      }
      console.log(value)
      if (value) {
        this.f.userName = value;
        this.dataflag = true;
        ss.UserCare.customerOption(this.f).then(rd => {
          this.EuName = rd;
        })
      } else {
        this.dataflag = false;
        this.f.userName = value;
      }

    },
    changesdatas() {
      this.dataflag = false;
    },
    changesdata(item) {
      console.log(item)
      this.dataflag = false;
      this.formLabelAlign.projectName = item.userName;
      this.f.userName = item.userName;
    },
    //通过用户名带出详细信息
    showAllFormList(value) {
      console.log(value)
      this.f.userName = value;
      ss.UserCare.customerOption(this.f).then(rd => {
        this.EuName = rd;
      })
    },
    //新增虚拟物料
    addFicPro(x) {
      if (x == '1') {
        this.showFicPro = true;
      } else if (x == '0') {
        this.showFicPro = false;
      }
    },
    ficMethod() {
      if (this.$router.history.current.query.xuniwuliao != null) {

        //前页数据
        this.qianyeshuju = this.$router.history.current.query;

        this.chanpinid = this.$router.history.current.query.xuniwuliao;

        var chushucanshu1 = {

          materialCode: this.$router.history.current.query.materialCode,
          xuniwuliao: this.$router.history.current.query.xuniwuliao,
          rowId: this.$router.history.current.query.rowId,

        };

        //获取信息
        this.gettableels(chushucanshu1);

        //若有驳回内容
      } else if (this.$route.query.ywid) {
        this.chongxintijiaoshow = true;
        //ywid
        this.ywid = this.$route.query.ywid;
        //instid
        this.instid = this.$route.query.instid;
        //taskid
        this.taskid = this.$route.query.taskid;
        //产品id
        this.chanpinid = this.ywid;
        var chushucanshu2 = {
          xuniwuliao: this.$route.query.ywid,
        };
        //获取信息
        this.gettableels(chushucanshu2);
      } else {
        //一打开新建页面就先给上一个新的uuid作为物料编码
        this.chanpinid = this.$util.getUuid();
      }
      //加载登陆人账号
      this.zy.cjrzh = this._user.usercode;
      //加载配置项
      this.huoquprizhixiang();
    },
    closeIt() {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextStep(i) {
      if (this.status == '1') {
        this.status = '2'
      } else if (this.status == '2') {
        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    //增加一行采购项目产品
    addCG() {
      var product = {};
      product.productName = '';
      product.type = '';
      product.productNum = '';
      product.productId = '';
      product.productDes = '';
      product.xuniFlag = '';
      product.optionsProductCg = [];
      this.proProduct.push(product);
    },
    //选择物料
    showProcuct1() {
      if (!this.formLabelAlign.customerId && this.projectType != '1') {
        this.$msg.msge("请先选择客户信息！")
        return;
      }
      //其他项目不涉及渠道判断内销
      if (this.projectType == '3') {
        if (!this.formLabelAlign.customerChannel) {
          this.$msg.msge("请先选择渠道信息！")
          return;
        }
      }
      this.showwuliaodialog1 = true;
    },


    //选择物料
    choseWuliao1(objs) {
      for (var i = 0; i < objs.length; i++) {
        var wl = this.wlToProject(objs[i]);
        //添加行项目
        this.proOtherProduct.push(wl);
        this.showwuliaodialog1 = false;
      }
    },
    LoudParts(objs) {
      this.loud = false;
      for (var i = 0; i < objs.length; i++) {
        var wl = this.wlToProjectnewloud(objs[i]);
        //添加行项目
        this.proProduct.push(wl);
        this.showwuliaodialog1 = false;
      }
    },
    LoudPartsTc(objs) {
      this.loudTc = false;
      for (var i = 0; i < objs.length; i++) {
        var wl = this.wlToProjectnewloud(objs[i]);
        //添加行项目
        this.proProduct.push(wl);
        this.showwuliaodialog1 = false;
      }
    },


    wlToProject(obj) {
      debugger
      console.log("选中的物料", obj)
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.type = obj.cpdlcode; //产品大类
      wl.typeName = obj.cpdlname; //产品大类名称
      wl.productId = obj.matecode;//物料编码
      wl.productName = obj.matedes;//产品型号名称
      wl.productDes = obj.matedes; // 产品描述
      wl.currency = obj.currency; // 产品描述
      wl.productNum = 0;//产品数量
      wl.productPrice = obj.jizhj;//产品基准价
      wl.expoPrice = wl.productPrice;//默认等于基准价
      wl.expoDiscount = 100;//默认一折不打
      return wl;
    },
    wlToProjectnewloud(obj) {
      debugger
      var wl = {};
      wl.id = this.$util.getUuid();
      // wl.type = obj.cpdlcode; //产品大类
      // wl.typeName = obj.cpdlname; //产品大类名称
      // wl.productId = obj.matecode;//物料编码
      // wl.productName = obj.matedes;//产品型号名称
      // wl.productDes = obj.matedes; // 产品描述
      // wl.currency = obj.currency; // 产品描述
      // wl.productNum = 0;//产品数量
      // wl.productPrice = obj.jizhj;//产品基准价
      // wl.expoPrice = wl.productPrice;//默认等于基准价
      // wl.expoDiscount = 100;//默认一折不打
      // wl.type = obj.cpdlcode; //产品大类
      wl.type = obj.proLevelOnecode; //产品大类
      wl.typeName = obj.proLevelOne; //产品大类名称
      wl.productId = obj.proCode;//物料编码
      wl.productName = obj.proModel;//产品型号名称
      wl.productDes = obj.proModel; // 产品描述
      wl.currency = this.formLabelAlign.currencyCode; // 产品描述
      wl.productNum = 0;//产品数量
      wl.productPrice = (obj.price * 10000).toFixed(2);//产品基准价
      wl.expoPrice = wl.productPrice;//默认等于基准价
      wl.expoDiscount = 100;//默认一折不打
      wl.funnelCode = obj.funnelCode;
      if (null != obj.packageProductId && obj.packageProductId != '') {
        wl.packageProductId = obj.packageProductId;
        wl.mainId = obj.mainId;
        wl.packageCode = obj.packageCode;
        wl.applyPrice = obj.finalPriceTc;
        wl.fenxiaoPrice = obj.fenxiaoPrice || 0;
        wl.biddenPrice = obj.biddenPrice || 0;
      }
      return wl;
    },


    //选择客户
    openShoudf() {
      this.showshdfdialog = true;
    },
    choseshoudf(obj) {
      console.log("选择的售达方1：", obj);
      if (this.projectType == '3') {
        ss.selectUserAgent.getQudaoXm(obj.usercode).then(rd => {
          console.log("rd", rd);
          if (rd == null && rd == "") {
            this.formLabelAlign.customerChannel = null;
            this.$msg.msge("该客户没有维护客户渠道信息，请联系管理员！")
            return;
          }
          this.salesregionListFilter = _.filter(this.salesregionList, (o) => {
            return _.split(obj.salesregion || '', ",").includes(o.code);
          });
          this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
            return _.split(rd || '', ",").includes(o.code);
          });
          if (this.customerChannelListFilter.length > 0) {
          } else {
            this.showshdfdialog = false
            this.formLabelAlign.customerChannel = null;
            this.$msg.msge("该客户没有维护客户渠道信息，请联系管理员！")
            return;
          }
          //进行强制数据渲染
          this.$forceUpdate();
        })
      }

      //清空物料
      if (this.formLabelAlign.customerId != obj.usercode) {
        this.proProduct = [];
      }

      this.formLabelAlign.customerName = obj.username;
      this.formLabelAlign.customerId = obj.usercode;
      this.formLabelAlign.projectArea = obj.areaname;
      this.formLabelAlign.currencyCode = obj.currency;
      this.showshdfdialog = false
      //已有经销商
      // if (this.order.soldToCode) {
      // }
    },


    expoType(v) {
      console.log(v)
      v.expoDiscount = 100;
      v.expoPrice = v.productPrice;
    },

    //查询合同编码
    checkUnFreeze() {
      if (this.proBidInfo.contractCode) {
        ss.ProService.htcheck(this.proBidInfo.contractCode).then(rd => {
          if (rd.obj) {
            this.$msg.msgs("验证成功");
            this.dialogVisible = false
            this.htok = true;
          } else {
            this.proBidInfo.contractCode = null;
            this.$msg.msge("合同编码不存在");
          }
        });
      } else {
        this.$msg.msge("请填写合同编号");
      }
    },
    //表格 只能输入数字方法
    onlynumber(scope) {
      let ex = /^[1-9][0-9]*$/
      if (ex.test(scope.amount)) {

      } else {
        scope.amount = 1;
      }
    },
    onlynumber2(row) {
      // 产品数量校验，非数字重置为1
      let numReg = /^[0-9]+(\.[0-9]+)?$/;
      if (!numReg.test(row.productNum)) {
        this.$set(row, 'productNum', 1);
      }

      // 转数字，防止空值
      const applyPrice = Number(row.applyPrice) || 0;
      const fenxiaoPrice = Number(row.fenxiaoPrice) || 0;
      const biddenPrice = Number(row.biddenPrice) || 0;

      let agentMaori = 0;
      let fenxiaoMaori = 0;

      // 代理商毛利 = (分销价 - 申请价) / 分销价 * 100%
      if (fenxiaoPrice > 0) {
        agentMaori = (((fenxiaoPrice - applyPrice) / fenxiaoPrice) * 100).toFixed(2);
      }

      // 分销毛利 = (终端价 - 分销价) / 终端价 * 100%
      if (biddenPrice > 0) {
        fenxiaoMaori = (((biddenPrice - fenxiaoPrice) / biddenPrice) * 100).toFixed(2);
      }

      // ✅ 强制更新行数据（解决不刷新的终极方案）
      this.$set(row, 'agentMaori', agentMaori);
      this.$set(row, 'fenxiaoMaori', fenxiaoMaori);
    },
    createdemand() {
      this.dialogVisible = true;

    },
    initType() {
      if (this.$route.query.ywid) {
        //如果是代办过来的,是展会项目
        //代办过来的
        // this.projectType = 1;
        // this.formLabelAlign.type = 1;
        this.formLabelAlign.id = this.$route.query.ywid;
        //展会项目回显
        this.newOrBid = false;
        this.bidquery();
      }
      if (this.$route.query.type) {
        //项目页进入new -新建   bid-修改中标信息
        if (this.$route.query.type == "new") {
          //type参数为new时，表示可以编辑
          this.newOrBid = false;
        } else if (this.$route.query.type == "bid") {
          this.bidquery();
        } else if (this.$route.query.type == "xm") {
          this.newOrBid = false;
          this.bidquery();
        }

      } else {
        //如果是需求进的此页面，可以编辑，带出需求是填写的信息
        this.newOrBid = false;
        //查询是不是需求调过来的
        this.xqquery();
      }
      //项目类型
      //项目类型:1-展会项目,2-外销,3-内销,4-租赁,5-采购,6-服务项目
      if (this.$route.query.protype) {
        this.projectType = this.$route.query.protype;
        this.formLabelAlign.type = this.$route.query.protype;
        debugger
      }

    },
    getUUid() {
      return this.$route.query.id ? this.$route.query.id : this.$util.getUuid();
    },
    getUUid2() {
      return this.$util.getUuid();
    },
    //自动计算总价
    changeTotal(v) {
      if (v.expoPrice && v.productNum) {
        v.expoTotal = new big(v.expoPrice).times(v.productNum);
      }
    },
    //修改中标信息,回显项目信息
    bidquery() {

      var id = this.$route.query.id ? this.$route.query.id : this.$route.query.ywid
      ss.ProService.proDetail(id).then(rd => {
        console.log("修改中标查看：", rd)
        this.formLabelAlign = rd;
        this.formLabelAlign.isSuccess = rd.isSuccess + "";
        this.formLabelAlign.id = rd.id + "";
        this.formLabelAlign.upload2 = rd.id;
        this.formLabelAlign.upload1 = rd.id;
        //客户信息赋值
        if (this.formLabelAlign.type == '1') {
          //展会项目
          this.times = rd.times;
        } else {
          // this.changeCustomer(this.formLabelAlign.customerId);
          if (rd.userProductInfoHaierList && rd.userProductInfoHaierList.length > 0) {
            this.productInfosHaier = rd.userProductInfoHaierList;
            this.productInfosHaier.forEach((item, index) => {
              this.selectProductHaier(item.category, index);

            });
          }
          if (rd.userProductInfoOtherList && rd.userProductInfoOtherList.length > 0) {
            this.productInfosOther = rd.userProductInfoOtherList;
          }
        }
        if (rd.proBidInfoList != null && rd.proBidInfoList.length > 0) {
          this.zhongbiaodata = rd.proBidInfoList;
          this.proBidInfo.bidTotal = this.zhongbiaodata[0].bidTotal || '';
          this.proBidInfo.contractCode = this.zhongbiaodata[0].contractCode || '';
        }
        if (rd.proProductInfoList && rd.proProductInfoList.length > 0) {
          this.proProduct = rd.proProductInfoList;
          this.norepeat = rd.proProductInfoList;
          // this.proProduct.forEach((item, index) => {
          //     this.selectProduct2(item.type, index);
          //     this.changeSmail(item);
          // });
        }
      });
    },
    addfilecallbackpo(v) {
      this.filepo = v;
    },
    addfilecallbackbjd(v) {
      this.filebjd = v;
    },
    //需求转化而来的
    xqquery() {
      var id = this.$route.query.id;
      this.formLabelAlign.demandType = this.$route.query.demandType;
      if (id != null) {
        if (this.formLabelAlign.demandType == '1') {//采购
          ss.UserDemand.demandDetail1(this.formLabelAlign.id).then(rd => {
            this.formLabelAlign = rd;
            this.projectType = 5;
            this.formLabelAlign = {
              id: this.getUUid(),
              type: 5,
              customerName: rd.euName,
              customerId: rd.euCode,
              demandId: id,
            }
            //客户信息赋值
            this.proProductcg = {
              // type: rd.levelname,
              productId: "",
              productName: "",
              productNum: rd.number,
              productDes: rd.proName + "-" + rd.resDescribe
            };
            // var sup = _.filter(this.optionsProduct1, {'id': this.proProductcg.type});
            // this.proProductcg.typeName = sup[0].levelname;
            // this.selectProduct2(this.proProductcg.type, 0);
            // this.selectProduct2Cg(this.proProductcg.type);
          })
        } else if (this.formLabelAlign.demandType == '2') {
          //订单需求转化为项目是3-内销
          ss.UserDemand.demandDetail2(this.formLabelAlign.id).then(rd => {
            console.log("返回的项目对象：", rd)
            this.formLabelAlign = rd;
            this.projectType = 3;
            var projectArea = this.$getDictName("YLRegion", rd.customer.areaCode);
            var customerChannel = this.$getDictName("sales_region", rd.customer.channelCode);
            var customerDept = this.$getDictName("YlCustomerAccountGroup_value", rd.customer.department);
            this.formLabelAlign = {
              type: 3,
              isSuccess: "2",
              proBidInfoList: [],
              proBidInfoList1: [],
              customerName: rd.euName,
              customerId: rd.euCode,
              expectConvertDate: rd.resConvDate,
              demandId: id,
              customerChannel: customerChannel,
              keyPerson: rd.customer.contactuserName,
              customerDept: customerDept,
              keyPersonTel: rd.customer.telephone,
              projectArea: projectArea

            }
            this.proProduct = [{
              type: rd.detail.proCode,
              productId: rd.detail.proModel,
              productNum: rd.detail.proNumber,
              productPrice: ''
            }];
            this.norepeat = this.proProduct;
            this.selectProduct2(this.proProduct[0].type, 0);
            this.changeSmail(this.proProduct[0]);
          })
        } else if (this.formLabelAlign.demandType == '3') {
          //资源问题不能转化为项目
          ss.UserDemand.demandDetail3(this.formLabelAlign.id).then(rd => {
            console.log("3返回的项目对象：", rd)
            this.formLabelAlign = rd;
          })
        }
      }
    },
    delIndex(index) {
      this.$msg.confirm("确认删除?", () => {
        this.proProduct.splice(index, 1);
        this.norepeat.splice(index, 1);
      })
    },
    delOtherIndex(index) {
      this.$msg.confirm("确认删除?", () => {
        this.proOtherProduct.splice(index, 1);
        this.noreOtherpeat.splice(index, 1);
      })
    },
    //增加海尔产品方法
    //增加产品方法
    // adds() {
    //     var a = {productPrice: '', type: '', productId: '', expoTotal: null, expoType: 1}
    //     this.proProduct.push(a)
    // },
    //客户信息初始化
    // showFormList(value) {
    //     this.newxm.userName = value;
    //     ss.ProService.customerSelect(this.newxm).then(rd => {
    //         this.optionsCustomer = rd;
    //     })
    // },
    //获取收货单位
    showFormList(value) {
      // console.log("value188776676","111111111111111111111111")
      var data = value;
      console.log("value188776676", data)
      ss.OrderMainService.getCompanyInfo(value).then(rd => {
        this.addrList = rd;
      })
    },
    //产品大类初始化
    selectProduct1() {
      ss.ProService.product1Select().then(rd => {
        this.optionsProduct1 = rd;
      })
    },
    //产品型号名称保存
    optionsProduct2Name(v, i) {
      var sup = _.filter(this.optionsProduct2[i], {'id': v.productId});
      v.productName = sup[0].levelname;
    },
    //品牌名称保存
    getBrandName(v, i) {
      var sup = _.filter(this.comperOption, {'id': v.brand});
      v.brandName = sup[0].brandName;
    },
    //大类修改时，当块数据proProduct[i]-v,index-i
    changeBig(v, i) {
      v.productId = '';
      v.productPrice = '';
      this.norepeat.splice(i, 1);
      var sup = _.filter(this.optionsProduct1, {'id': v.type});
      v.typeName = sup[0].levelname;
      this.selectProduct2(v.type, i);

    },
    //大类修改时，查询小类列表 v.type大类id-v,index-i
    selectProduct2(v, i) {
      ss.ProService.product2Select(v).then(rd => {
        this.optionsProduct2[i] = rd;
        this.$set(this.optionsProduct2, i, rd);
      })
    },
    //大类修改时，当块数据proProduct[i]-v,index-i
    changeBigCg(v) {
      v.productName = '';
      v.productId = '';
      v.xuniFlag = '';
      v.productPrice = '';
      var sup = _.filter(this.optionsProduct1, {'id': v.type});
      v.typeName = sup[0].levelname;
      this.selectProduct2Cg(v);
    },
    //大类修改时，查询小类列表 v.type大类id-v,index-i
    selectProduct2Cg(v) {
      ss.ProService.product2OemSelect(v.type).then(rd => {
        v.optionsProductCg = rd;
        //this.$set(this.optionsProduct2,i,rd);
      })
    },
    //产品型号名称保存
    optionsProduct2Cg(v, a, b) {
      console.log(v, a, b)
      // var sup = _.filter(v.optionsProductCg, {'id': v.productId});
      // v.productName = sup[0].levelname;
      if (v.optionsProductCg && v.optionsProductCg.length > 0) {
        var abb = 0;
        for (var i = 0; i < v.optionsProductCg.length; i++) {
          if (a == v.optionsProductCg[i].levelname && b == v.optionsProductCg[i].id) {
            v.productId = v.optionsProductCg[i].id
            abb++;
          }
        }
      }
      if (abb == 1) {
        v.xuniFlag = 0
      } else {
        v.xuniFlag = 1
        v.productId = ''
      }
    },
    //小类修改，当块数据proProduct[i]-v
    changeSmail(v) {
      var data = {
        mdmMaterialInfoPrice: {
          materialid: v.productId,
          leltypecode: 1,
          type: "03",
          currency: "CNY"
        }
      }
      ss.ProService.product2Detail(data).then(rd => {
        if (rd.obj && rd.obj.length > 0) {
          v.proCode = rd.obj[0].mdmMaterialInfoPrice.materialid;
          v.productPrice = rd.obj[0].mdmMaterialInfoPrice.value;
          v.currency = rd.obj[0].mdmMaterialInfoPrice.currency;
        } else {
          v.productPrice = null;
        }
      })
    },
    changeSmailPro(v, i) {
      this.norepeat.splice(i, 1);
      if (_.find(this.norepeat, {productId: v.productId})) {
        this.$msg.msge("该物料已选择,请勿重复选择!")
        v.productId = "";
        return;
      } else {
        this.norepeat.push(v);
        this.changeSmail(v);
      }
    },
    //用户信息赋值
    changeCustomer(c) {
      this.optionsCustomer.forEach((item, index) => {
        if (c == item.userCode) {
          this.formLabelAlign.customerId = item.userCode;
          this.formLabelAlign.customerName = item.userName;
          this.$set(this.formLabelAlign, 'customerDept', item.department);
          this.$set(this.formLabelAlign, 'keyPersonTel', item.telephone);
          this.$set(this.formLabelAlign, 'keyPerson', item.contactuserName);
          this.formLabelAlign.projectArea = item.areaCode ? this.$getDictName("YLRegion", item.areaCode) : "";
          this.formLabelAlign.customerChannel = item.channelCode ? this.$getDictName("sales_region", item.channelCode) : "";
          if (item.userType && item.userType == '1') {
            this.formLabelAlign.userType = 1
          } else {
            this.formLabelAlign.userType = 2
          }
        }
      })
    },
    submitPro() {
      console.log(this.formLabelAlign);
      //合并海尔的竞品和其他品牌的竞品
      this.formLabelAlign.userProductInfoList = [];
      this.productInfosHaier.forEach((item, index) => {
        if (item.category) {
          item.fromId = this.formLabelAlign.id;
          this.formLabelAlign.userProductInfoList.push(item);
        }
      })
      this.productInfosOther.forEach((item, index) => {
        if (item.category) {
          item.fromId = this.formLabelAlign.id;
          this.formLabelAlign.userProductInfoList.push(item);
        }
      })
      if (this.formLabelAlign.isSuccess != 2) {
        this.proBidInfo.isSuccess = this.formLabelAlign.isSuccess;
        this.formLabelAlign.proBidInfoList = [this.proBidInfo];
      }
      //newOrBid  new-新建值为false    bid-修改中标信息值为true
      if (this.newOrBid) {
        //true   修改中标信息
        this.submitBid();
      } else {
        this.submitNew();
      }
    },
    submitNew() {
      this.formLabelAlign.proBidInfoList1 = this.zhongbiaodata;
      if (this.formLabelAlign.type == '3') {
        if (this.formLabelAlign.proBidInfoList1.length < 2) {
          this.$msg.msge("请至少填写2个竞争对手再提交！");
          subflag1 = false;
          return false;
        }
        for (var i = 0; i < this.formLabelAlign.proBidInfoList1.length; i++) {
          if (!this.formLabelAlign.proBidInfoList1[i].otherBrand) {
            this.$msg.msge("请填写其他投标品牌");
            subflag1 = false;
            return false;
          }
          if (!this.formLabelAlign.proBidInfoList1[i].otherModel) {
            this.$msg.msge("请填写投标型号");
            subflag1 = false;
            return false;
          }
          if (!this.formLabelAlign.proBidInfoList1[i].otherComp) {
            this.$msg.msge("请填写其他投标公司");
            subflag1 = false;
            return false;
          }
          if (!this.formLabelAlign.proBidInfoList1[i].otherTotal) {
            this.$msg.msge("请填写其他公司投标总额");
            subflag1 = false;
            return false;
          }
        }
        if (this.proProduct.length < 1) {
          this.$msg.msge("请至少填写1个产品信息再提交！");
          subflag1 = false;
          return false;
        }
      }


      console.log(this.formLabelAlign + "看看小李");
      var subflag1 = false;
      var subflag2 = false;
      var subflag3 = true;
      this.$refs['formLabelAlign1'].validate((valid) => {
        if (valid) {
          subflag1 = true;
        } else {
          this.$msg.msge("请完善项目信息后再提交！");
          return false;
        }
      });
      if (this.formLabelAlign.type != 5 && this.formLabelAlign.type != 1) {
        this.$refs['formLabelAlign2'].validate((valid) => {
          if (valid) {
            subflag2 = true;
          } else {
            this.$msg.msge("请完善用户信息后再提交！");
            return false;
          }
        });
      } else if (this.formLabelAlign.type == '5') {
        // this.$refs['formLabelAlign2'].validate((valid) => {
        //     if (valid) {
        subflag2 = true;
        //     } else {
        //         this.$msg.msge("请完善产品信息后再提交！");
        //         return false;
        //     }
        // });
        // this.proProduct = [this.proProductcg];

      } else if (this.formLabelAlign.type == '1') {
        //展会项目
        subflag2 = true;
        this.formLabelAlign.saleStartTime = this.times[0];
        this.formLabelAlign.saleEndTime = this.times[1];
        //展会项目状态为1-提交审核
        this.formLabelAlign.status = 1;
        if (!this.formLabelAlign.saleStartTime || !this.formLabelAlign.saleEndTime) {
          this.$msg.msge("请完善项目有效期后再提交！");
          subflag1 = false;
        }
        subflag3 = true;
      }

      this.proProduct.forEach((item, index) => {
        if (this.formLabelAlign.type == '1') {
          if (!item.productId || (!item.expoPrice && !item.expoDiscount)) {
            subflag3 = false;
            return false;
          }
          //如果是展会产品
          item.isExpo = 1;
          item.expoEndDate = this.formLabelAlign.saleEndTime;
        } else {
          debugger
          if (!(item.productId || item.productName) || !item.type || !item.productNum) {
            subflag3 = false;
            return false;
          }
        }
        if(this.isGnsc){
          if (!item.otherFees || !item.otherFeesDesc || !item.shipmentPrice) {
            subflag3 = false;
            return false;
          }
        }
      })

      if (!subflag3) {
        console.log(this.proProduct)
        this.$msg.msge("请完善表格中的产品信息后再提交！");
      }
      if(this.isGnsc){
        const moneyReg = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
        for(var i=0;i<this.proProduct.length;i++){
          // otherFees 校验
          if (!this.proProduct[i].otherFees || !moneyReg.test(this.proProduct[i].otherFees)) {
            subflag3 = false;
            this.$message.error(`第${i + 1}行 ${this.proProduct[i].productId || ''}：其他费用请填写数字`);
            return false;
          }
          // shipmentPrice 校验
          if (!this.proProduct[i].shipmentPrice || !moneyReg.test(this.proProduct[i].shipmentPrice)) {
            subflag3 = false;
            this.$message.error(`第${i + 1}行 ${this.proProduct[i].productId || ''}：经销商出货单价请填写数字`);
            return false;
          }
        }
      }
      //外销附件
      if (this.filepo && this.filepo.length > 0) {
        this.formLabelAlign.poId = this.filepo[0].id;
      }
      if (this.filebjd && this.filebjd.length > 0) {
        this.formLabelAlign.bjdId = this.filebjd[0].id;
      }
      //合并海尔的竞品和其他品牌的竞品
      if (subflag1 && subflag2 && subflag3) {
        this.formLabelAlign.proProductInfoList = this.proProduct
        this.formLabelAlign.proProductInfoOtherList = this.proOtherProduct
        console.log('产品详情121', this.formLabelAlign);

        this.$msg.confirm("确认提交项目信息?", () => {

          ss.ProService.savePro(this.formLabelAlign).then(rd => {
            this.$msg.msgs("提交成功！");
            this.$router.push("/xiangmu/pm");
          })
        })
      }


    },

    submitBid() {
      if (this.formLabelAlign.isSuccess == '0') {
        ss.ProService.saveBidLoss(this.formLabelAlign).then(rd => {
          this.$msg.msgs("提交成功！");
          this.$router.push("/xiangmu/pm");
        })
      }
      if (this.formLabelAlign.isSuccess == '1') {
        ss.ProService.saveBidWin(this.formLabelAlign).then(rd => {
          this.$msg.msgs("提交成功！");
          this.$router.push("/xiangmu/pm");
        })
      }
      if (this.formLabelAlign.isSuccess == '2') {
        this.$msg.msge("请完善中标信息！");
      }


    },
    cancelPro() {
      this.$router.push({path: "/xiangmu/pm"});
    },
    //竞品使用
    handlePreview() {

    },
    handleRemove() {
    },
    //竞品切换
    selectC(item) {
      this.categorys = item;
    },
    delUserProduction1(index) {
      this.productInfosHaier.splice(index, 1)
    },
    delUserProduction2(index) {
      this.productInfosOther.splice(index, 1)
    },
    addComp() {
      var id = this.getUUid2();
      var a = {id: id, type: 2, fromType: 1}
      this.productInfosOther.push(a)
    },
    addHaier() {
      var id = this.getUUid2();
      var a = {id: id, type: 1, fromType: 1, specification: '', brand: "Haier"}
      this.productInfosHaier.push(a)
    },
    changeArea(query) {
      console.log("接受到的参数", query);
      //根据选择的销售区域带出对应的渠道

      let value = {
        usercode: this.formLabelAlign.customerId,
        areaCode: query
      }
      ss.OrderMainService.getChannelByArea(value).then(rd => {
        console.log(rd);
        this.customerChannelListFilter = rd.msg;
        console.log(this.customerChannelListFilter)
        if (this.customerChannelListFilter.length > 0) {
          //    this.order.customerChannelCode = null;
        } else {
          this.showshdfdialog = false
          this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
          return;
        }
      })
      this.proProduct = [];
    },
    //大类修改时，当块数据proProduct[i]-v,index-i
    changeBigHaierBig(v, i) {
      v.specification = '';
      this.selectProductHaier(v.category, i);
    },
    //海尔内部竞品，大类修改时，查询小类列表 v.type大类id-v,index-i
    selectProductHaier(v, i) {
      ss.ProService.product2Select(v).then(rd => {
        this.optionsProductHaier[i] = rd;
        this.$set(this.optionsProductHaier, i, rd);
      })
    },
    selectProductBig() {
      ss.ProService.product1Select().then(rd => {
        this.optionsProductBig = rd;
      })
    },
    selectComperOption() {
      ss.ProService.comperOption({}).then(rd => {
        this.comperOption = rd;
      })
    },
    //时间限制
    beginDate(v) {
      if (v.purchaseDate) {  //如果结束时间不为空，则小于结束时间
        if (v.purchaseDate < v.exfactoryDate) {
          this.$msg.msge("购买日期不能小于出厂日期");
          v.exfactoryDate = "";
        }
      }
    },
    processDate(v) {
      if (v.exfactoryDate) {//如果有出厂日期
        //如果购买日期小于出厂日期
        if (v.purchaseDate < v.exfactoryDate) {
          this.$msg.msge("购买日期不能小于出厂日期");
          v.purchaseDate = "";
        }
      }
    },

    /*↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓虚拟物料方法↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓*/
    //重新提交
    chongxintijiao() {
      //更新修改的信息
      this.zancunortijiao(3);
      var chongxin = {
        yewuzhujian: this.ywid,
        taskid: this.taskid,
      }

      //重新提交
      ss.chanpin.chongxintijiao(chongxin).then(rd => {
        if (rd.obj == true) {
          this.$msg.msgs(rd.msg)
          //返回
          this.$router.push({path: '/chanp/productManage'});
        }
      })
    },

    huoquprizhixiang() {
      //    不知道干啥用的 原页面就是空的
    },
    //加载配置项
    gettableels(q) {

      ss.chanpin.idaorrowIdbselectList(q).then(rd => {
        this.vw = rd.obj;
        var ss = {
          ywlx: rd.obj.oemType || '',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
          wlms: rd.obj.materialDescrition || '',// 物料描述   //产品型号
          jbdw: rd.obj.primaryUom || '',//基本计量单位
          wlz: rd.obj.materialGroupCode || '',//物料组
          jwlh: rd.obj.oldMaterialNumber || '',// 旧物料号
          cpz: rd.obj.department || '',//产品组
          sys: rd.obj.labStudio || '',//实验室/办公室
          wbwlz: rd.obj.extMtlGroup || '',//外部物料组
          sfl: rd.obj.tax || '',//税分类
          cpzch: rd.obj.productRegNum || '',//产品注册号
          cytj: rd.obj.shipCondition || '',//储运条件
          cd: rd.obj.placeOrigin || '',//产地
          cpcc: rd.obj.productHierarchy || '',//产品层次  (关联产品层级编码id)
          scs: rd.obj.manufacturer || '',//生产商
          xwbm: rd.obj.zattr5u || '',//小微编码
          styjsx: rd.obj.ecology || '',//生态硬件属性
          stsr: rd.obj.ecologyIn || '',//生态收入
          youxiaoqi: rd.obj.zcpyxq || '',//产品有效期(年)
          hybzms: rd.obj.industryStdDesc || '',//行业标准描述
          cjrzh: rd.obj.cucode || '',//创建人编码
          wlxh: rd.obj.materialDescrition || '',// 物料描述   //产品型号
          shenpiyijian: rd.obj.zhenshishenpijindu == null ? '' : rd.obj.zhenshishenpijindu.split("_")[2] || '',//审批意见
        }
        this.zy = ss;
      })
    },
    zancunortijiao(q) {
      this.$refs['zy'].validate((valid) => {
        if (valid) {
          var canshu = {
            id: this.chanpinid,//虚拟物料id
            materialCode: this.chanpinid,// 真实物料id里先也存一个虚拟物料id
            oemType: this.zy.ywlx,
            materialDescrition: this.zy.wlxh,
            primaryUom: this.zy.jbdw,
            materialGroupCode: this.zy.wlz,
            oldMaterialNumber: this.zy.jwlh,
            Department: this.zy.cpz,
            labStudio: this.zy.sys,
            extMtlGroup: this.zy.wbwlz,
            Tax: this.zy.sfl,
            productRegNum: this.zy.cpzch,
            shipCondition: this.zy.cytj,
            placeOrigin: this.zy.cd,
            productHierarchy: this.zy.cpcc,
            manufacturer: this.zy.scs,
            zattr5u: this.zy.xwbm,
            ecology: this.zy.styjsx,
            ecologyIn: this.zy.stsr,
            zcpyxq: parseInt(this.zy.youxiaoqi),
            industryStdDesc: this.zy.hybzms,
            cucode: this.zy.cjrzh,
            chongxintijiao: q == 3 ? 1 : null,//3是重新提交
          }
          if (q == '0') {//暂存
            this.zancun(canshu);
          } else if (q == '4') {
            ss.chanpin.addzancun(canshu).then(rd => {
              this.xuniwuliaoId = rd.obj.id;
              this.$msg.msgs(rd.msg);
              // this.fanhui();
              this.chanpinid = rd.obj.xuniwuliao;
              var ss = {
                id: rd.obj.id,
                ywlx: rd.obj.oemType,
                wlxh: rd.obj.materialDescrition,
                jbdw: rd.obj.primaryUom,
                wlz: rd.obj.materialGroupCode,
                jwlh: rd.obj.oldMaterialNumber,
                cpz: rd.obj.department,
                sys: rd.obj.labStudio,
                wbwlz: rd.obj.extMtlGroup,
                sfl: rd.obj.tax,
                cpzch: rd.obj.productRegNum,
                cytj: rd.obj.shipCondition,
                cd: rd.obj.placeOrigin,
                cpcc: rd.obj.productHierarchy,
                scs: rd.obj.manufacturer,
                xwbm: rd.obj.zattr5u,
                styjsx: rd.obj.ecology,
                stsr: rd.obj.ecologyIn,
                youxiaoqi: rd.obj.zcpyxq,
                hybzms: rd.obj.industryStdDesc,
                cjrzh: rd.obj.cucode
              }
              this.zy = ss;

              //展示到列表
              var product = {};
              product.productName = canshu.materialDescrition;
              product.type = canshu.productHierarchy;
              product.productNum = '';
              product.productId = canshu.materialDescrition;
              product.productDes = '';
              product.xuniFlag = '1';
              product.xuniwuliaoId = this.xuniwuliaoId;
              this.proProduct.push(product);
              console.log('虚拟物料id', product.xuniwuliaoId);
              this.showFicPro = false;

            })
          } else {//提交
            this.querentijiao(canshu);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    querentijiao(q) {
      ss.chanpin.addtijiao(q).then(rd => {
        if (q.chongxintijiao == null) {
          this.$msg.msgs(rd.msg);
          // this.fanhui();
        }
      })
    },
    zancun(q) {
      ss.chanpin.addzancun(q).then(rd => {
        this.xuniwuliaoId = rd.obj.id;
        this.$msg.msgs(rd.msg);
        // this.fanhui();
        this.chanpinid = rd.obj.xuniwuliao;
        var ss = {
          id: rd.obj.id,
          ywlx: rd.obj.oemType,
          wlxh: rd.obj.materialDescrition,
          jbdw: rd.obj.primaryUom,
          wlz: rd.obj.materialGroupCode,
          jwlh: rd.obj.oldMaterialNumber,
          cpz: rd.obj.department,
          sys: rd.obj.labStudio,
          wbwlz: rd.obj.extMtlGroup,
          sfl: rd.obj.tax,
          cpzch: rd.obj.productRegNum,
          cytj: rd.obj.shipCondition,
          cd: rd.obj.placeOrigin,
          cpcc: rd.obj.productHierarchy,
          scs: rd.obj.manufacturer,
          xwbm: rd.obj.zattr5u,
          styjsx: rd.obj.ecology,
          stsr: rd.obj.ecologyIn,
          youxiaoqi: rd.obj.zcpyxq,
          hybzms: rd.obj.industryStdDesc,
          cjrzh: rd.obj.cucode
        }
        this.zy = ss;
      })
    },
    //返回上一页
    fanhui() {
      this.$router.push({path: '/chanp/productManage'});
    },
    showzhezhao() {
      ss.salesList.toshow(this.toshow).then(rd => {
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    //获取当前登录人公司
    getCompany () {
      ss.contractService.getUserCompany().then(rd => {
        if (rd.f) {
          if (rd.msg == '1RK0' || rd.msg == '9390' || rd.msg == '6200' || rd.msg == '1JC0' || rd.msg == '1D90' || rd.msg == '9370') {
            this.isGnsc = true;
            this.gscode = rd.msg;
          }
        }
      })
    },
    showLd() {
      if (this.formLabelAlign.customerName == undefined || this.formLabelAlign.customerName == '') {
        this.$msg.msge("请先选择客户名称信息！")
        return;
      }
      if (this.formLabelAlign.customerChannel == undefined || this.formLabelAlign.customerChannel == '') {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      if (this.formLabelAlign.toCompanyname == undefined || this.formLabelAlign.toCompanyname == '') {
        this.$msg.msge("请先选择收货单位！")
        return;
      }
      this.loud = true;
    },
    showLdTc() {
      if (this.formLabelAlign.customerName == undefined || this.formLabelAlign.customerName == '') {
        this.$msg.msge("请先选择客户名称信息！")
        return;
      }
      if (this.formLabelAlign.customerChannel == undefined || this.formLabelAlign.customerChannel == '') {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      if (this.formLabelAlign.toCompanyname == undefined || this.formLabelAlign.toCompanyname == '') {
        this.$msg.msge("请先选择收货单位！")
        return;
      }
      this.loudTc = true;
    },
    changeReform() {
      if (this.formLabelAlign.isReform == '1') {
        this.reformFlag = true;
      } else {
        this.reformFlag = false;
      }
    },

    changeFenxiao() {
      if (this.formLabelAlign.isFenxiao == '1') {
        this.fenxiaoFlag = true;
      } else {
        this.fenxiaoFlag = false;
      }
      // 遍历整个产品列表，清空分销价 + 分销毛利
      this.proProduct.forEach(item => {
        // 强制设置分销价 = 0
        this.$set(item, 'fenxiaoPrice', 0);
        // 强制设置分销毛利 = 0
        this.$set(item, 'fenxiaoMaori', 0);
      });
    },
    getDetailById(id) {
      ss.loudnew.selectByFunnelIdXs(id).then(rd => {
        console.log(rd)
        if (rd.f) {
          // this.formLabelAlign = res.obj
          const products = rd.obj.products ? rd.obj.products.map(item => ({
            typeName: item.proLevelOne,
            productId: item.proCode,
            productNum: item.num,
            productName: item.proModel,
            productPrice: item.price || 0 // 补充必需字段
          })) : [];

          this.formLabelAlign.projectName = rd.obj.projectName
          let param = {
            pageSize: 10,
            pageNo: 1,
            total: 0,
            xmtype: this.projectType,
            usercodename: rd.obj.agentName
          }
          ss.selectUserAgent.selectUserAgentPageXm(param).then(res => {
            let obj = res.records[0]
            this.choseshoudf(obj)
            // 3. 在 choseshoudf 执行后，重新赋值产品数据
            this.proProduct = products;
            // 强制触发响应式更新（确保表格渲染）
            this.$forceUpdate();
            let list = _.filter(this.salesregionList, (o) => {
              return _.split(obj.salesregion || '', ",").includes(o.code);
            });
            let saleList = _.filter(list, (o) => {
              return _.split(rd.obj.province || '', ",").includes(o.name);
            });
            this.formLabelAlign.salesregion = saleList[0].code
          })
          this.formLabelAlign.customerChannel = rd.obj.customerChannel
          this.formLabelAlign.customerDept = rd.obj.deptName
          this.formLabelAlign.keyPerson = rd.obj.chargePerson
          this.formLabelAlign.keyPersonTel = rd.obj.phone
          this.formLabelAlign.toCompanyname = rd.obj.customerName
          // this.proProduct = rd.obj.products
          if (rd.obj.products && rd.obj.products.length) {
            // 仅在数据有效时执行映射
            this.proProduct = rd.obj.products.map(item => ({
              typeName: item.proLevelOne,
              productId: item.proCode,
              productNum: item.num,
              productName: item.proModel,
              // 补充表格必需的其他字段
              productPrice: item.price || 0, // 基准价格（表格有此列，必须赋值）
            }));
            // 映射后打印，确认结构正确
            console.log("映射后的 proProduct：", this.proProduct);
          } else {
            console.warn("产品数据为空或格式错误");
            this.proProduct = []; // 避免 undefined 导致表格异常
          }
        }
      })
    }
  },
  created() {

    this.showzhezhao();
    this.getCompany();
    this.salesregionList = this.$store.getters.dictlist("YlSalesArea_chanpin");
    this.zclk = this.$store.getters.hasRole('swyl_tc_zclkgly');
    let funnelId = this.$route.query.funnelId
    if (funnelId) {
      this.getDetailById(funnelId)
    }
  }
}
</script>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: -0.7rem;
    left: 0;
  }

  .step2 {
    top: -0.7rem;
    left: 0;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
}

.xiangmuBoxs {
  width: 100%;
  position: absolute;
  top: 0.4rem;
  left: 0;
  height: 2rem;
  overflow-y: auto;
  background: #fff;
  ox-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border: 1px solid #E4E7ED;
  border-radius: 4px;
  padding: 0.05rem 0;
  z-index: 9999;

  .xiangmus {
    width: 100%;
    font-size: 0.1rem;
    color: #606266;
    height: 0.3rem;
    padding: 0 0.1rem;
    line-height: 0.3rem;
    cursor: pointer;

    &:hover {
      color: #2381e8;
      background: #F5F7FA;
    }
  }
}
</style>
<style>
.clclass .h-formbLine .h-elformWrap-2 {
  width: 33.33%;
}

.clclass .h-formbLine .el-form-item__label {
  width: 35%;
  padding-right: 0rem;
}

.clclass .h-formbLine .el-form-item__content {
  width: 65%;
}

.clclass .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10%
}

.clclass .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 90%;
}

.ljjtablepaddings9 .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}

.ljjtablepaddings9 .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}
</style>
